/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAccount = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      owner
      groups
      active
      status
      businessName
      displayName
      accountNumber
      externalId
      externalStatus
      accountType
      defaultBillToAccountId
      lotNumberPrefix
      color
      defaultWeightUOM
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      creditLimit
      overLimit
      overDue
      einNumber
      skipInvoice
      email
      phone
      fax
      website
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      billingAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      contacts {
        name
        email
        phone
        description
      }
      billingContacts {
        name
        email
        phone
        description
      }
      billingEmail
      invoiceSubject
      invoiceAttachments
      invoiceCustomFields {
        id
        name
        type
        display
        required
      }
      addressState
      reloadYardId
      inboundCustomFields {
        id
        name
        type
        display
        required
      }
      inboundInstructions
      secondaryReview
      inboundSkipSignature
      inboundPhotos
      podEmail
      podPhotos
      podAttachments
      podSubject
      inboundAdviceInputs
      inboundEventTypeId
      lotType
      lotNumberOverride
      fifoLotNumber
      carlotLotNumber
      verifyInboundRailCar
      trackInboundSeals
      requireDefaultZone
      outboundCustomFields {
        id
        name
        type
        display
        required
      }
      outboundInstructions
      posEmail
      posPhotos
      posAttachments
      posSubject
      outboundSkipSignature
      outboundPhotos
      outboundReview
      outboundAdviceInputs
      outboundEventTypeId
      generatePickupNumber
      mustTarp
      verifyOutboundRailCar
      trackOutboundSeals
      inventoryCustomFields {
        id
        name
        type
        display
        required
      }
      inventoryPrimaryField
      inventoryPhotos
      trackInventorySeals
      isBarcodeRequired
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      services {
        items {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const listAccounts = /* GraphQL */ `
  query ListAccounts(
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAisle = /* GraphQL */ `
  query GetAisle($id: ID!) {
    getAisle(id: $id) {
      id
      owner
      groups
      active
      reloadYardId
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      locations {
        items {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        nextToken
      }
      bays
      levels
      positions
      totalLocations
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      capacityUsed
      length
      width
      sortKey
      topDownPickOrder
      createdAt
      updatedAt
    }
  }
`;
export const listAisles = /* GraphQL */ `
  query ListAisles(
    $filter: ModelAisleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAisles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAnnouncement = /* GraphQL */ `
  query GetAnnouncement($id: ID!) {
    getAnnouncement(id: $id) {
      id
      active
      activatedAt
      message
      urgency
      forceRefresh
      link
      tenantId
      createdAt
      updatedAt
    }
  }
`;
export const listAnnouncements = /* GraphQL */ `
  query ListAnnouncements(
    $filter: ModelAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnnouncements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        activatedAt
        message
        urgency
        forceRefresh
        link
        tenantId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getApiKey = /* GraphQL */ `
  query GetApiKey($id: ID!) {
    getApiKey(id: $id) {
      id
      active
      groups
      reloadYardId
      name
      keyId
      createdBy
      deletedBy
      createdAt
      updatedAt
    }
  }
`;
export const listApiKeys = /* GraphQL */ `
  query ListApiKeys(
    $filter: ModelApiKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApiKeys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        groups
        reloadYardId
        name
        keyId
        createdBy
        deletedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getArea = /* GraphQL */ `
  query GetArea($id: ID!) {
    getArea(id: $id) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      color
      areaType
      sortKey
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAreas = /* GraphQL */ `
  query ListAreas(
    $filter: ModelAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAreas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAssetType = /* GraphQL */ `
  query GetAssetType($id: ID!) {
    getAssetType(id: $id) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      maxConcurrentBookings
      createdAt
      updatedAt
    }
  }
`;
export const listAssetTypes = /* GraphQL */ `
  query ListAssetTypes(
    $filter: ModelAssetTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssetTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        maxConcurrentBookings
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAudit = /* GraphQL */ `
  query GetAudit($id: ID!) {
    getAudit(id: $id) {
      id
      owner
      groups
      active
      status
      createdAt
      createDateTime
      notes
      reloadYardId
      processedItems
      processedLocations
      skippedItems
      nextItem
      nextItems {
        locationIdx
        owner
        name
      }
      direction
      accountId
      accountName
      assignedTo
      locations
      startDateTime
      endDateTime
      updatedAt
    }
  }
`;
export const listAudits = /* GraphQL */ `
  query ListAudits(
    $filter: ModelAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAudits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        createdAt
        createDateTime
        notes
        reloadYardId
        processedItems
        processedLocations
        skippedItems
        nextItem
        nextItems {
          locationIdx
          owner
          name
        }
        direction
        accountId
        accountName
        assignedTo
        locations
        startDateTime
        endDateTime
        updatedAt
      }
      nextToken
    }
  }
`;
export const getBarcode = /* GraphQL */ `
  query GetBarcode($id: ID!) {
    getBarcode(id: $id) {
      id
      owner
      groups
      active
      status
      value
      isScanned
      scannedIn
      scannedOut
      reloadYardId
      inboundShipmentId
      inventoryId
      locationId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listBarcodes = /* GraphQL */ `
  query ListBarcodes(
    $filter: ModelBarcodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBarcodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        value
        isScanned
        scannedIn
        scannedOut
        reloadYardId
        inboundShipmentId
        inventoryId
        locationId
        inventoryItemId
        inventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCapability = /* GraphQL */ `
  query GetCapability($id: ID!) {
    getCapability(id: $id) {
      id
      active
      sortKey
      name
      description
      requiresValue
      requiredValueLabel
      quantity
      createdAt
      updatedAt
    }
  }
`;
export const listCapabilitys = /* GraphQL */ `
  query ListCapabilitys(
    $filter: ModelCapabilityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCapabilitys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        sortKey
        name
        description
        requiresValue
        requiredValueLabel
        quantity
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCarrier = /* GraphQL */ `
  query GetCarrier($id: ID!) {
    getCarrier(id: $id) {
      id
      owner
      active
      groups
      businessName
      dbaName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      companyId
      reloadYardId
      users {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCarriers = /* GraphQL */ `
  query ListCarriers(
    $filter: ModelCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarriers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCarrierCompany = /* GraphQL */ `
  query GetCarrierCompany($id: ID!) {
    getCarrierCompany(id: $id) {
      id
      groups
      businessName
      email
      phone
      normalizedEmail
      normalizedPhone
      identifiers {
        scheme
        value
      }
      yards {
        items {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCarrierCompanys = /* GraphQL */ `
  query ListCarrierCompanys(
    $filter: ModelCarrierCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        groups
        businessName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        yards {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCarrierIdentifierClaim = /* GraphQL */ `
  query GetCarrierIdentifierClaim($id: ID!) {
    getCarrierIdentifierClaim(id: $id) {
      id
      scheme
      value
      companyId
      identifiers {
        scheme
        value
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCarrierIdentifierClaims = /* GraphQL */ `
  query ListCarrierIdentifierClaims(
    $filter: ModelCarrierIdentifierClaimFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierIdentifierClaims(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheme
        value
        companyId
        identifiers {
          scheme
          value
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCarrierUser = /* GraphQL */ `
  query GetCarrierUser($id: ID!) {
    getCarrierUser(id: $id) {
      id
      status
      cognitoId
      email
      contactEmail
      unsubscribed
      firstName
      lastName
      phone
      userType
      driverCode
      suspendedAt
      suspendedBy
      suspensionReason
      reloadYardCarriers {
        items {
          id
          owner
          groups
          active
          deleted
          carrierUserId
          carrierId
          reloadYardId
          businessName
          firstName
          lastName
          email
          phone
          type
          description
          acl
          notes
          blockAccess
          createdVia
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCarrierUsers = /* GraphQL */ `
  query ListCarrierUsers(
    $filter: ModelCarrierUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCarrierUserReloadYardCarrier = /* GraphQL */ `
  query GetCarrierUserReloadYardCarrier($id: ID!) {
    getCarrierUserReloadYardCarrier(id: $id) {
      id
      owner
      groups
      active
      deleted
      carrierUserId
      user {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      businessName
      firstName
      lastName
      email
      phone
      type
      description
      acl
      photo {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes
      blockAccess
      createdVia
      createdAt
      updatedAt
    }
  }
`;
export const listCarrierUserReloadYardCarriers = /* GraphQL */ `
  query ListCarrierUserReloadYardCarriers(
    $filter: ModelCarrierUserReloadYardCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierUserReloadYardCarriers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        deleted
        carrierUserId
        user {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        businessName
        firstName
        lastName
        email
        phone
        type
        description
        acl
        photo {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes
        blockAccess
        createdVia
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getChargeRule = /* GraphQL */ `
  query GetChargeRule($id: ID!) {
    getChargeRule(id: $id) {
      id
      owner
      active
      groups
      accountId
      reloadYardId
      event
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      billingUOM
      reloadYardCommodityId
      carrierType
      carrierEquipmentTypeId
      areaId
      zoneId
      graduatedRates {
        days
        rate
      }
      minCharge
      maxCharge
      execution
      frequency
      feeAccrual
      freeDaysPolicy
      freeDays
      freeCars
      createdAt
      updatedAt
    }
  }
`;
export const listChargeRules = /* GraphQL */ `
  query ListChargeRules(
    $filter: ModelChargeRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChargeRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        active
        groups
        accountId
        reloadYardId
        event
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        billingUOM
        reloadYardCommodityId
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        graduatedRates {
          days
          rate
        }
        minCharge
        maxCharge
        execution
        frequency
        feeAccrual
        freeDaysPolicy
        freeDays
        freeCars
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getChecklist = /* GraphQL */ `
  query GetChecklist($id: ID!) {
    getChecklist(id: $id) {
      id
      owner
      groups
      active
      reloadYardId
      resourceId
      name
      description
      processName
      checklistItems {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      reloadYardCommodityId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const listChecklists = /* GraphQL */ `
  query ListChecklists(
    $filter: ModelChecklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChecklists(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        resourceId
        name
        description
        processName
        checklistItems {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        reloadYardCommodityId
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCommodity = /* GraphQL */ `
  query GetCommodity($id: ID!) {
    getCommodity(id: $id) {
      id
      active
      sortKey
      name
      description
      defaultUnits
      locationLoadType
      validUom
      inventoryFields
      enableCounter
      prompt
      createdAt
      updatedAt
    }
  }
`;
export const listCommoditys = /* GraphQL */ `
  query ListCommoditys(
    $filter: ModelCommodityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommoditys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        sortKey
        name
        description
        defaultUnits
        locationLoadType
        validUom
        inventoryFields
        enableCounter
        prompt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      status
      cognitoId
      email
      unsubscribed
      firstName
      lastName
      phone
      reloadYardAccounts {
        items {
          id
          owner
          active
          groups
          email
          lastName
          acl
          description
          customerId
          reloadYardId
          accountId
          accountName
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        cognitoId
        email
        unsubscribed
        firstName
        lastName
        phone
        reloadYardAccounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomerReloadYardAccount = /* GraphQL */ `
  query GetCustomerReloadYardAccount($id: ID!) {
    getCustomerReloadYardAccount(id: $id) {
      id
      owner
      active
      groups
      email
      lastName
      acl
      description
      customerId
      customer {
        id
        status
        cognitoId
        email
        unsubscribed
        firstName
        lastName
        phone
        reloadYardAccounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      accountId
      accountName
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCustomerReloadYardAccounts = /* GraphQL */ `
  query ListCustomerReloadYardAccounts(
    $filter: ModelCustomerReloadYardAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerReloadYardAccounts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        active
        groups
        email
        lastName
        acl
        description
        customerId
        customer {
          id
          status
          cognitoId
          email
          unsubscribed
          firstName
          lastName
          phone
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        accountId
        accountName
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEventType = /* GraphQL */ `
  query GetEventType($id: ID!) {
    getEventType(id: $id) {
      id
      owner
      groups
      active
      reloadYardId
      areaId
      name
      description
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      duration
      bufferTime
      resourceName
      numberOfResources
      assetTypeId
      assetType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        maxConcurrentBookings
        createdAt
        updatedAt
      }
      workflow
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listEventTypes = /* GraphQL */ `
  query ListEventTypes(
    $filter: ModelEventTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFile = /* GraphQL */ `
  query GetFile($id: ID!) {
    getFile(id: $id) {
      id
      owner
      groups
      active
      reloadYardId
      displayName
      rawFileName
      description
      contentDate
      category
      visibility
      file {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listFiles = /* GraphQL */ `
  query ListFiles(
    $filter: ModelFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        displayName
        rawFileName
        description
        contentDate
        category
        visibility
        file {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getHelpPage = /* GraphQL */ `
  query GetHelpPage($id: ID!) {
    getHelpPage(id: $id) {
      id
      active
      isLive
      url
      topic
      name
      content
      kbFiles {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbMedia {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      kbContent {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const listHelpPages = /* GraphQL */ `
  query ListHelpPages(
    $filter: ModelHelpPageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHelpPages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        isLive
        url
        topic
        name
        content
        kbFiles {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        kbMedia {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        kbContent {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        updatedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getHistoryNote = /* GraphQL */ `
  query GetHistoryNote($id: ID!) {
    getHistoryNote(id: $id) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      text
      dateTime
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const listHistoryNotes = /* GraphQL */ `
  query ListHistoryNotes(
    $filter: ModelHistoryNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHistoryNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        reloadYardId
        parentId
        parentType
        text
        dateTime
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInboundShipment = /* GraphQL */ `
  query GetInboundShipment($id: ID!) {
    getInboundShipment(id: $id) {
      id
      owner
      groups
      active
      status
      state
      poNumber
      normalizedPoNumber
      lotNumber
      lotNumberOverride
      shipFrom
      carrierType
      originCarrier
      carrierName
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      lotType
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      totalUOM
      skipInvoice
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      advisedBy
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      collectedDateTime
      stripeBillingDateTime
      daysOnDemurrageClock
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptNumber
      assignedTo
      workflowType
      unloadedBy
      reviewedBy
      secondaryReview
      verificationRequired
      stockImport
      sit
      returnShipment
      returnOutboundShipmentId
      returnReason
      hasException
      unsafeShipment
      unsafeShipmentNote
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      checklistId
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      containerDrop
      containerNumber
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      stepName
      sealNumbers
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      braData {
        id
        owner
        groups
        reloadYardId
        accountId
        braSessionId
        braRawData
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listInboundShipments = /* GraphQL */ `
  query ListInboundShipments(
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInventorie = /* GraphQL */ `
  query GetInventorie($id: ID!) {
    getInventorie(id: $id) {
      id
      owner
      groups
      active
      status
      lotNumber
      poNumber
      normalizedPoNumber
      railCarNumber
      normalizedRailCarNumber
      receivedAt
      depletedAt
      lastOutboundId
      turnDays
      quantityAdvised
      quantityReceived
      quantityPrecount
      quantityOnHand
      altQuantityOnHand
      quantityPhysical
      quantityCommitted
      altQuantityCommitted
      quantityMismatch
      inventoryUOM
      returnShipmentLineItemId
      pcs
      pcsHeight
      pcsWidth
      pcsLength
      pcsOnHand
      pcsCommitted
      weight
      weightUOM
      verificationRequired
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleList
      containerNumber
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      productName
      braRawProductName
      rawDataInventoryId
      productCode
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      sortKey
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      workOrderId
      workOrder {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      auditId
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      aggregateInventoryId
      inventoryItems {
        items {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      createdAt
      updatedAt
    }
  }
`;
export const listInventories = /* GraphQL */ `
  query ListInventories(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInventoryItem = /* GraphQL */ `
  query GetInventoryItem($id: ID!) {
    getInventoryItem(id: $id) {
      id
      owner
      groups
      quantityOnHand
      altQuantityOnHand
      quantityCommitted
      altQuantityCommitted
      pcsOnHand
      pcsCommitted
      hasException
      isDamaged
      originOfDamage
      otherException
      otherExceptionNote
      status
      accountId
      inboundShipmentId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      barcode
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
      reloadYardId
      unloadedAt
      unloadedBy
      depletedAt
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      barcodes {
        items {
          id
          owner
          groups
          active
          status
          value
          isScanned
          scannedIn
          scannedOut
          reloadYardId
          inboundShipmentId
          inventoryId
          locationId
          inventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      history {
        type
        date
        by
        text
        public
      }
      createdAt
      updatedAt
    }
  }
`;
export const listInventoryItems = /* GraphQL */ `
  query ListInventoryItems(
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInvoice = /* GraphQL */ `
  query GetInvoice($id: ID!) {
    getInvoice(id: $id) {
      id
      owner
      groups
      active
      status
      invoiceNumber
      externalId
      externalUrl
      externalStatus
      poNumber
      poNumbers
      railCarNumbers
      pickupNumbers
      event
      paymentTermId
      paymentTerm {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      paymentTerms
      createDateTime
      dueDate
      overDue
      sentDate
      paidDate
      lineItems {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      subtotal
      discount
      adjustment
      tax
      total
      balance
      payments {
        id
        amount
        paymentDate
        method
        reference
        memo
        recordedBy
        recordedAt
      }
      paymentReferences
      notes
      customFields
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      contact {
        name
        email
        phone
        description
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      reloadYardId
      reloadYard {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listInvoices = /* GraphQL */ `
  query ListInvoices(
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInvoiceService = /* GraphQL */ `
  query GetInvoiceService($id: ID!) {
    getInvoiceService(id: $id) {
      id
      owner
      groups
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      serviceId
      service {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      event
      externalId
      sortKey
      accountId
      reloadYardId
      inboundShipmentId
      outboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      quantity
      units
      unitCost
      amount
      itemTax
      taxRate {
        taxCode
        name
        taxRate
      }
      itemTotal
      serviceNote
      serviceDate
      createdAt
      updatedAt
    }
  }
`;
export const listInvoiceServices = /* GraphQL */ `
  query ListInvoiceServices(
    $filter: ModelInvoiceServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoiceServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        event
        externalId
        sortKey
        accountId
        reloadYardId
        inboundShipmentId
        outboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        quantity
        units
        unitCost
        amount
        itemTax
        taxRate {
          taxCode
          name
          taxRate
        }
        itemTotal
        serviceNote
        serviceDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      owner
      groups
      active
      reloadYardId
      accountName
      name
      type
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      aisle {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      bay
      level
      position
      capacityAllocated
      capacityUsed
      length
      width
      sortKey
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      productId
      productName
      bulkCapacity
      bulkUnits
      isContaminated
      containerNumber
      tags {
        items {
          id
          owner
          groups
          reloadYardId
          locationId
          tagId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getLocationTag = /* GraphQL */ `
  query GetLocationTag($id: ID!) {
    getLocationTag(id: $id) {
      id
      owner
      groups
      reloadYardId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      tagId
      tag {
        id
        owner
        groups
        reloadYardId
        name
        description
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listLocationTags = /* GraphQL */ `
  query ListLocationTags(
    $filter: ModelLocationTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        reloadYardId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        tagId
        tag {
          id
          owner
          groups
          reloadYardId
          name
          description
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getLog = /* GraphQL */ `
  query GetLog($id: ID!) {
    getLog(id: $id) {
      id
      status
      createdAt
      appType
      tenantId
      user
      message
      exception
      appVersion
      url
      context
      owner
      updatedAt
    }
  }
`;
export const listLogs = /* GraphQL */ `
  query ListLogs(
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        createdAt
        appType
        tenantId
        user
        message
        exception
        appVersion
        url
        context
        owner
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOutboundShipment = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      owner
      groups
      active
      status
      state
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      pickupNumber
      consigneePoNumber
      normalizedPoNumber
      normalizedPickupNumber
      normalizedConsigneePoNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      carrierType
      carrier
      carrierName
      carrierId
      driverId
      driver {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      driverName
      bolNumber
      railCarNumber
      normalizedRailCarNumber
      carrierEquipmentTypeId
      railEquipmentType {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      truckEquipmentType {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      mustTarp
      didTarp
      containerPickup
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      collectedDateTime
      deliveryDateTime
      daysOnDemurrageClock
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      totalUOM
      skipInvoice
      photos {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          bucket
          region
          key
          type
          name
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      sealNumber
      assignedTo
      instructions
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      trackCar {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          totalQuantityReturned
          units
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      invoicedServices {
        items {
          id
          owner
          groups
          invoiceId
          serviceId
          event
          externalId
          sortKey
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          quantity
          units
          unitCost
          amount
          itemTax
          itemTotal
          serviceNote
          serviceDate
          createdAt
          updatedAt
        }
        nextToken
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      timeslotId
      gateCheckInId
      shipWithGroupId
      shipWithIds
      timeslot {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      advisedBy
      inspectedBy
      stepName
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      hasException
      returnShipment
      returnReason
      createdAt
      updatedAt
    }
  }
`;
export const listOutboundShipments = /* GraphQL */ `
  query ListOutboundShipments(
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPaymentTerm = /* GraphQL */ `
  query GetPaymentTerm($id: ID!) {
    getPaymentTerm(id: $id) {
      id
      owner
      groups
      reloadYardId
      name
      code
      type
      dueDays
      dayOfMonthDue
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listPaymentTerms = /* GraphQL */ `
  query ListPaymentTerms(
    $filter: ModelPaymentTermFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentTerms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPhoto = /* GraphQL */ `
  query GetPhoto($id: ID!) {
    getPhoto(id: $id) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      bucket
      region
      key
      type
      name
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const listPhotos = /* GraphQL */ `
  query ListPhotos(
    $filter: ModelPhotoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPhotos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        reloadYardId
        parentId
        parentType
        bucket
        region
        key
        type
        name
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      owner
      groups
      active
      accountId
      reloadYardId
      name
      altNames
      productCode
      reloadYardCommodityId
      category
      defaultUOM
      defaultWeightUOM
      unit
      pcs
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      height
      width
      length
      pcsHeight
      pcsWidth
      pcsLength
      lowInventoryThreshold
      totalInventoryQuantity
      totalQuantityOnHand
      totalQuantityCommitted
      lowInventoryAlert
      customFields
      color
      status
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      velocityStats {
        id
        owner
        groups
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        stats
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProductStats = /* GraphQL */ `
  query GetProductStats($id: ID!) {
    getProductStats(id: $id) {
      id
      owner
      groups
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      stats
      createdAt
      updatedAt
    }
  }
`;
export const listProductStatss = /* GraphQL */ `
  query ListProductStatss(
    $filter: ModelProductStatsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductStatss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        stats
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRailEquipmentType = /* GraphQL */ `
  query GetRailEquipmentType($id: ID!) {
    getRailEquipmentType(id: $id) {
      id
      owner
      groups
      active
      name
      arrTypeCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listRailEquipmentTypes = /* GraphQL */ `
  query ListRailEquipmentTypes(
    $filter: ModelRailEquipmentTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRailEquipmentTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRawData = /* GraphQL */ `
  query GetRawData($id: ID!) {
    getRawData(id: $id) {
      id
      owner
      groups
      reloadYardId
      accountId
      braSessionId
      braRawData
      createdAt
      updatedAt
    }
  }
`;
export const listRawDatas = /* GraphQL */ `
  query ListRawDatas(
    $filter: ModelRawDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRawDatas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        reloadYardId
        accountId
        braSessionId
        braRawData
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getReloadYard = /* GraphQL */ `
  query GetReloadYard($id: ID!) {
    getReloadYard(id: $id) {
      id
      owner
      groups
      active
      status
      name
      phone
      fax
      email
      website
      street
      city
      state
      zipCode
      country
      latitude
      longitude
      geofence
      geofenceToleranceMeters
      geofenceEnabled
      geofenceEnforced
      driverCheckInEnabled
      driverIdentificationRequired
      driverIdScanRequired
      driverCheckInGraceMinutes
      driverCheckInWithoutAppointment
      driverInstructions
      postCheckInMessage
      driverStops {
        label
        message
      }
      driverIdImageRetention
      lotCapacity
      trackCapacity
      warehouseCapacity
      servingCarrier
      railHighway
      ast
      externalCompanyId
      taxRates {
        taxCode
        name
        taxRate
      }
      paymentTerms {
        items {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceNumberPrefix
      invoiceCounter
      remittanceAddress {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolCounter
      receiptCounter
      fileCategories {
        key
        name
      }
      mapImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      logoImage {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      areas {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      zones {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      yardCommodities {
        items {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      subscription {
        customerId
        subscriptionId
        priceId
        name
        status
      }
      tosAccept {
        acceptTimeStamp
        cognitoId
        email
        userAgent
        ip
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      timeZone
      railEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      truckEquipmentTypes {
        items {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        nextToken
      }
      assetTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        nextToken
      }
      eventTypes {
        items {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        nextToken
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
        nextToken
      }
      apiKeys {
        items {
          id
          active
          groups
          reloadYardId
          name
          keyId
          createdBy
          deletedBy
          createdAt
          updatedAt
        }
        nextToken
      }
      invoicesProcessedAt
      reportsProcessedAt
      createdAt
      updatedAt
    }
  }
`;
export const listReloadYards = /* GraphQL */ `
  query ListReloadYards(
    $filter: ModelReloadYardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReloadYards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getReloadYardCapability = /* GraphQL */ `
  query GetReloadYardCapability($id: ID!) {
    getReloadYardCapability(id: $id) {
      id
      reloadYardId
      capabilityId
      owner
      groups
      active
      verified
      requiredValue
      capability {
        id
        active
        sortKey
        name
        description
        requiresValue
        requiredValueLabel
        quantity
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listReloadYardCapabilitys = /* GraphQL */ `
  query ListReloadYardCapabilitys(
    $filter: ModelReloadYardCapabilityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReloadYardCapabilitys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        capabilityId
        owner
        groups
        active
        verified
        requiredValue
        capability {
          id
          active
          sortKey
          name
          description
          requiresValue
          requiredValueLabel
          quantity
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getReloadYardCommodity = /* GraphQL */ `
  query GetReloadYardCommodity($id: ID!) {
    getReloadYardCommodity(id: $id) {
      id
      reloadYardId
      commodityId
      owner
      groups
      active
      verified
      units
      showCounter
      sortKey
      commodity {
        id
        active
        sortKey
        name
        description
        defaultUnits
        locationLoadType
        validUom
        inventoryFields
        enableCounter
        prompt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listReloadYardCommoditys = /* GraphQL */ `
  query ListReloadYardCommoditys(
    $filter: ModelReloadYardCommodityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReloadYardCommoditys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSavedAddress = /* GraphQL */ `
  query GetSavedAddress($id: ID!) {
    getSavedAddress(id: $id) {
      id
      owner
      groups
      reloadYardId
      accountId
      name
      street
      city
      state
      zipCode
      country
      phone
      createdAt
      updatedAt
    }
  }
`;
export const listSavedAddresss = /* GraphQL */ `
  query ListSavedAddresss(
    $filter: ModelSavedAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSavedAddresss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        reloadYardId
        accountId
        name
        street
        city
        state
        zipCode
        country
        phone
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSeal = /* GraphQL */ `
  query GetSeal($id: ID!) {
    getSeal(id: $id) {
      id
      active
      owner
      groups
      reloadYardId
      accountId
      accountName
      referenceId
      referenceName
      barcode
      isScanned
      createdAt
      createdBy
      validated
      reValidated
      brokenAt
      brokenBy
      description
      status
      updatedAt
    }
  }
`;
export const listSeals = /* GraphQL */ `
  query ListSeals(
    $filter: ModelSealFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSeals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        owner
        groups
        reloadYardId
        accountId
        accountName
        referenceId
        referenceName
        barcode
        isScanned
        createdAt
        createdBy
        validated
        reValidated
        brokenAt
        brokenBy
        description
        status
        updatedAt
      }
      nextToken
    }
  }
`;
export const getService = /* GraphQL */ `
  query GetService($id: ID!) {
    getService(id: $id) {
      id
      owner
      groups
      active
      status
      reloadYardId
      accountName
      accountId
      name
      description
      taxRate {
        taxCode
        name
        taxRate
      }
      unit
      pcs
      car
      tl
      mbf
      lf
      sf
      msf
      sqm
      gal
      l
      lbs
      tn
      cwt
      kg
      mt
      ft
      m
      createdAt
      updatedAt
    }
  }
`;
export const listServices = /* GraphQL */ `
  query ListServices(
    $filter: ModelServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSetupData = /* GraphQL */ `
  query GetSetupData($id: ID!) {
    getSetupData(id: $id) {
      id
      owner
      groups
      status
      cognitoId
      firstName
      lastName
      businessName
      setupData
      submitDate
      approvalDate
      approvedBy
      createdAt
      updatedAt
    }
  }
`;
export const listSetupDatas = /* GraphQL */ `
  query ListSetupDatas(
    $filter: ModelSetupDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSetupDatas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        status
        cognitoId
        firstName
        lastName
        businessName
        setupData
        submitDate
        approvalDate
        approvedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getShipmentLineItem = /* GraphQL */ `
  query GetShipmentLineItem($id: ID!) {
    getShipmentLineItem(id: $id) {
      id
      owner
      groups
      active
      status
      sortKey
      lotNumber
      poNumber
      totalQuantityToPick
      totalQuantityReturned
      units
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      pickupPhoto {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      outboundShipmentId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountId
      reloadYardId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inventoryItems {
        items {
          id
          owner
          groups
          reloadYardId
          outboundShipmentId
          shipmentLineItemId
          inventoryId
          inventoryItemId
          quantityToPick
          quantityReturned
          scannedOut
          loadedBy
          units
          status
          hasException
          barcodeException
          barcodeExceptionNote
          otherException
          otherExceptionNote
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listShipmentLineItems = /* GraphQL */ `
  query ListShipmentLineItems(
    $filter: ModelShipmentLineItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShipmentLineItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        sortKey
        lotNumber
        poNumber
        totalQuantityToPick
        totalQuantityReturned
        units
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        pickupPhoto {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        inventoryItems {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getShipmentLineItemInventoryItem = /* GraphQL */ `
  query GetShipmentLineItemInventoryItem($id: ID!) {
    getShipmentLineItemInventoryItem(id: $id) {
      id
      owner
      groups
      reloadYardId
      outboundShipmentId
      shipmentLineItemId
      inventoryId
      inventoryItemId
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      quantityToPick
      quantityReturned
      scannedOut
      loadedBy
      units
      status
      hasException
      barcodeException
      barcodeExceptionNote
      otherException
      otherExceptionNote
      createdAt
      updatedAt
    }
  }
`;
export const listShipmentLineItemInventoryItems = /* GraphQL */ `
  query ListShipmentLineItemInventoryItems(
    $filter: ModelShipmentLineItemInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShipmentLineItemInventoryItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        outboundShipmentId
        shipmentLineItemId
        inventoryId
        inventoryItemId
        inventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        quantityToPick
        quantityReturned
        scannedOut
        loadedBy
        units
        status
        hasException
        barcodeException
        barcodeExceptionNote
        otherException
        otherExceptionNote
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSupportRequest = /* GraphQL */ `
  query GetSupportRequest($id: ID!) {
    getSupportRequest(id: $id) {
      id
      owner
      groups
      active
      status
      reloadYardId
      subject
      description
      requirements
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      submittedAt
      approvedPriceCents
      maxRevisions
      approvedBy
      approvedAt
      quoteExpiresAt
      estimatedDays
      stripeCheckoutSessionId
      stripePaymentIntentId
      stripePaymentStatus
      paidAt
      startedAt
      deliveredAt
      revisionCount
      deliveryNotes
      deliveryAttachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listSupportRequests = /* GraphQL */ `
  query ListSupportRequests(
    $filter: ModelSupportRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSupportRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        reloadYardId
        subject
        description
        requirements
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        submittedAt
        approvedPriceCents
        maxRevisions
        approvedBy
        approvedAt
        quoteExpiresAt
        estimatedDays
        stripeCheckoutSessionId
        stripePaymentIntentId
        stripePaymentStatus
        paidAt
        startedAt
        deliveredAt
        revisionCount
        deliveryNotes
        deliveryAttachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTag = /* GraphQL */ `
  query GetTag($id: ID!) {
    getTag(id: $id) {
      id
      owner
      groups
      reloadYardId
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const listTags = /* GraphQL */ `
  query ListTags(
    $filter: ModelTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        reloadYardId
        name
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTask = /* GraphQL */ `
  query GetTask($id: ID!) {
    getTask(id: $id) {
      id
      owner
      groups
      status
      reloadYardId
      createdAt
      updatedAt
      name
      description
      assignedTo
      assignedToName
      allowReassign
      link
      priority
      reference
      category
      dueDate
      lateDate
      completedBy
      completedDate
      resolvedDate
      resolvedBy
      note
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
    }
  }
`;
export const listTasks = /* GraphQL */ `
  query ListTasks(
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        status
        reloadYardId
        createdAt
        updatedAt
        name
        description
        assignedTo
        assignedToName
        allowReassign
        link
        priority
        reference
        category
        dueDate
        lateDate
        completedBy
        completedDate
        resolvedDate
        resolvedBy
        note
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const getTimeslot = /* GraphQL */ `
  query GetTimeslot($id: ID!) {
    getTimeslot(id: $id) {
      id
      owner
      groups
      status
      reloadYardId
      year
      month
      week
      day
      time
      startTime
      endTime
      inboundId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outboundId
      outboundShipment {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      accountName
      accountId
      eventTypeId
      eventType {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      carrierId
      carrier {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      carrierUserId
      carrierUser {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listTimeslots = /* GraphQL */ `
  query ListTimeslots(
    $filter: ModelTimeslotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeslots(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTrackCar = /* GraphQL */ `
  query GetTrackCar($id: ID!) {
    getTrackCar(id: $id) {
      id
      active
      owner
      areaId
      zoneId
      aisleId
      trackId
      eodTrackId
      location {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      locationFullName
      reloadYardId
      accountId
      shipmentId
      parentType
      inbound {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      outbound {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      railCarNumber
      sortKey
      eodSortKey
      movementLogs {
        trackCarId
        sortKey
        movedAt
        movedBy
      }
      updatedAt
      updatedBy
      createdAt
    }
  }
`;
export const listTrackCars = /* GraphQL */ `
  query ListTrackCars(
    $filter: ModelTrackCarFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTrackCars(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      nextToken
    }
  }
`;
export const getTruckEquipmentType = /* GraphQL */ `
  query GetTruckEquipmentType($id: ID!) {
    getTruckEquipmentType(id: $id) {
      id
      owner
      groups
      active
      name
      dotSpecCode
      dotClassCode
      length
      reloadYardId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listTruckEquipmentTypes = /* GraphQL */ `
  query ListTruckEquipmentTypes(
    $filter: ModelTruckEquipmentTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTruckEquipmentTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      owner
      groups
      active
      status
      cognitoId
      type
      firstName
      lastName
      fullName
      phone
      email
      unsubscribed
      address {
        name
        street
        city
        state
        zipCode
        country
        phone
      }
      reloadYardId
      acl
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        cognitoId
        type
        firstName
        lastName
        fullName
        phone
        email
        unsubscribed
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        reloadYardId
        acl
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWorkChargeRule = /* GraphQL */ `
  query GetWorkChargeRule($id: ID!) {
    getWorkChargeRule(id: $id) {
      id
      owner
      groups
      reloadYardId
      parentId
      parentType
      chargeRuleId
      chargeRule {
        id
        owner
        active
        groups
        accountId
        reloadYardId
        event
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        billingUOM
        reloadYardCommodityId
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        graduatedRates {
          days
          rate
        }
        minCharge
        maxCharge
        execution
        frequency
        feeAccrual
        freeDaysPolicy
        freeDays
        freeCars
        createdAt
        updatedAt
      }
      quantity
      sortKey
      invoiceServiceId
      createdAt
      updatedAt
    }
  }
`;
export const listWorkChargeRules = /* GraphQL */ `
  query ListWorkChargeRules(
    $filter: ModelWorkChargeRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkChargeRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        reloadYardId
        parentId
        parentType
        chargeRuleId
        chargeRule {
          id
          owner
          active
          groups
          accountId
          reloadYardId
          event
          serviceId
          billingUOM
          reloadYardCommodityId
          carrierType
          carrierEquipmentTypeId
          areaId
          zoneId
          minCharge
          maxCharge
          execution
          frequency
          feeAccrual
          freeDaysPolicy
          freeDays
          freeCars
          createdAt
          updatedAt
        }
        quantity
        sortKey
        invoiceServiceId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWorkOrder = /* GraphQL */ `
  query GetWorkOrder($id: ID!) {
    getWorkOrder(id: $id) {
      id
      owner
      groups
      active
      status
      state
      workType
      poNumber
      normalizedPoNumber
      totalUOM
      skipInvoice
      createDateTime
      startDateTime
      endDateTime
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      assignedTo
      workflowType
      processedBy
      verificationRequired
      hasException
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      billToAccount {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      workOrderItems {
        items {
          id
          owner
          groups
          active
          status
          workOrderId
          sortKey
          poNumber
          quantityToProcess
          units
          accountId
          reloadYardId
          inputInventoryId
          inputInventoryItemId
          createdAt
          updatedAt
        }
        nextToken
      }
      outputInventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      manualCharges {
        items {
          id
          owner
          groups
          reloadYardId
          parentId
          parentType
          chargeRuleId
          quantity
          sortKey
          invoiceServiceId
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
        required
      }
      stepName
      createdAt
      updatedAt
    }
  }
`;
export const listWorkOrders = /* GraphQL */ `
  query ListWorkOrders(
    $filter: ModelWorkOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWorkOrderItem = /* GraphQL */ `
  query GetWorkOrderItem($id: ID!) {
    getWorkOrderItem(id: $id) {
      id
      owner
      groups
      active
      status
      workOrderId
      sortKey
      poNumber
      quantityToProcess
      units
      history {
        type
        date
        by
        text
        public
      }
      accountId
      reloadYardId
      inputInventoryId
      inputInventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      inputInventoryItemId
      inputInventoryItem {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listWorkOrderItems = /* GraphQL */ `
  query ListWorkOrderItems(
    $filter: ModelWorkOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkOrderItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        workOrderId
        sortKey
        poNumber
        quantityToProcess
        units
        history {
          type
          date
          by
          text
          public
        }
        accountId
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        inputInventoryItemId
        inputInventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getZapierHook = /* GraphQL */ `
  query GetZapierHook($id: ID!) {
    getZapierHook(id: $id) {
      id
      groups
      active
      reloadYardId
      event
      zapId
      url
      link
      options
      createdAt
      updatedAt
    }
  }
`;
export const listZapierHooks = /* GraphQL */ `
  query ListZapierHooks(
    $filter: ModelZapierHookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listZapierHooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        groups
        active
        reloadYardId
        event
        zapId
        url
        link
        options
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getZapierAction = /* GraphQL */ `
  query GetZapierAction($id: ID!) {
    getZapierAction(id: $id) {
      id
      groups
      active
      reloadYardId
      event
      name
      description
      counter
      createdAt
      updatedAt
    }
  }
`;
export const listZapierActions = /* GraphQL */ `
  query ListZapierActions(
    $filter: ModelZapierActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listZapierActions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        groups
        active
        reloadYardId
        event
        name
        description
        counter
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getZone = /* GraphQL */ `
  query GetZone($id: ID!) {
    getZone(id: $id) {
      id
      owner
      groups
      active
      reloadYardId
      name
      prefix
      accountId
      leasedArea
      leasedAreaUOM
      areaId
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        nextToken
      }
      color
      zoneType
      reloadYardCommodityId
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listZones = /* GraphQL */ `
  query ListZones(
    $filter: ModelZoneFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listZones(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCarrierUserIdentity = /* GraphQL */ `
  query GetCarrierUserIdentity($id: ID!) {
    getCarrierUserIdentity(id: $id) {
      id
      status
      rekognitionFaceId
      rekognitionCollection
      faceImageKey
      idDocType
      idDocLast4
      idDocExpiry
      idDocState
      idDocClass
      idDocLastName
      idDocFirstInitial
      idDocImageKey
      idDocRetention
      idDocCapturedAt
      idDocSource
      idDocReplacedAt
      idDocDeletedAt
      consentAt
      consentVersion
      consentLocale
      consentTextHash
      faceConsentDeclinedAt
      consentWithdrawnAt
      consentWithdrawnBy
      enrolledVia
      enrolledBy
      enrolledAtYardId
      createdAt
      updatedAt
    }
  }
`;
export const listCarrierUserIdentitys = /* GraphQL */ `
  query ListCarrierUserIdentitys(
    $filter: ModelCarrierUserIdentityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierUserIdentitys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        rekognitionFaceId
        rekognitionCollection
        faceImageKey
        idDocType
        idDocLast4
        idDocExpiry
        idDocState
        idDocClass
        idDocLastName
        idDocFirstInitial
        idDocImageKey
        idDocRetention
        idDocCapturedAt
        idDocSource
        idDocReplacedAt
        idDocDeletedAt
        consentAt
        consentVersion
        consentLocale
        consentTextHash
        faceConsentDeclinedAt
        consentWithdrawnAt
        consentWithdrawnBy
        enrolledVia
        enrolledBy
        enrolledAtYardId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDriverSession = /* GraphQL */ `
  query GetDriverSession($id: ID!) {
    getDriverSession(id: $id) {
      id
      reloadYardId
      carrierUserId
      gateCheckInId
      ip
      userAgent
      windowStart
      searchCount
      identifyCount
      enrollCount
      captureCount
      revoked
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const listDriverSessions = /* GraphQL */ `
  query ListDriverSessions(
    $filter: ModelDriverSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDriverSessions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        carrierUserId
        gateCheckInId
        ip
        userAgent
        windowStart
        searchCount
        identifyCount
        enrollCount
        captureCount
        revoked
        expiresAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getGateCheckIn = /* GraphQL */ `
  query GetGateCheckIn($id: ID!) {
    getGateCheckIn(id: $id) {
      id
      owner
      groups
      reloadYardId
      driverSessionId
      carrierUserId
      carrierId
      carrierName
      driverName
      shipmentKey
      inboundId
      outboundId
      timeslotId
      scheduledDateTime
      referenceEntered
      driverNameEntered
      truckPlate
      trailerNumber
      latitude
      longitude
      locationAccuracy
      status
      dockAssignment
      arrivedAt
      calledAt
      completedAt
      updatedBy
      outboundIds
      createdAt
      updatedAt
    }
  }
`;
export const listGateCheckIns = /* GraphQL */ `
  query ListGateCheckIns(
    $filter: ModelGateCheckInFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGateCheckIns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        reloadYardId
        driverSessionId
        carrierUserId
        carrierId
        carrierName
        driverName
        shipmentKey
        inboundId
        outboundId
        timeslotId
        scheduledDateTime
        referenceEntered
        driverNameEntered
        truckPlate
        trailerNumber
        latitude
        longitude
        locationAccuracy
        status
        dockAssignment
        arrivedAt
        calledAt
        completedAt
        updatedBy
        outboundIds
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const accountByActiveByName = /* GraphQL */ `
  query AccountByActiveByName(
    $reloadYardId: ID
    $activeBusinessName: ModelAccountAccountByActiveByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountByActiveByName(
      reloadYardId: $reloadYardId
      activeBusinessName: $activeBusinessName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const accountByEmail = /* GraphQL */ `
  query AccountByEmail(
    $reloadYardId: ID
    $email: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountByEmail(
      reloadYardId: $reloadYardId
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const accountByExternalId = /* GraphQL */ `
  query AccountByExternalId(
    $reloadYardId: ID
    $externalId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountByExternalId(
      reloadYardId: $reloadYardId
      externalId: $externalId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const accountByLotPrefix = /* GraphQL */ `
  query AccountByLotPrefix(
    $reloadYardId: ID
    $lotNumberPrefix: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountByLotPrefix(
      reloadYardId: $reloadYardId
      lotNumberPrefix: $lotNumberPrefix
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const aisleByActiveBySortKey = /* GraphQL */ `
  query AisleByActiveBySortKey(
    $reloadYardId: ID
    $activeSortKey: ModelAisleAisleByActiveBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAisleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    aisleByActiveBySortKey(
      reloadYardId: $reloadYardId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const aisleByActiveByAreaBySortKey = /* GraphQL */ `
  query AisleByActiveByAreaBySortKey(
    $areaId: ID
    $activeSortKey: ModelAisleAisleByActiveByAreaBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAisleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    aisleByActiveByAreaBySortKey(
      areaId: $areaId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const aisleByActiveByZoneBySortKey = /* GraphQL */ `
  query AisleByActiveByZoneBySortKey(
    $zoneId: ID
    $activeSortKey: ModelAisleAisleByActiveByZoneBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAisleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    aisleByActiveByZoneBySortKey(
      zoneId: $zoneId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        locations {
          nextToken
        }
        bays
        levels
        positions
        totalLocations
        capacityUsed
        length
        width
        sortKey
        topDownPickOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const announcementsByActiveByUrgencyByDate = /* GraphQL */ `
  query AnnouncementsByActiveByUrgencyByDate(
    $active: String
    $urgencyActivatedAt: ModelAnnouncementAnnouncementsByActiveByUrgencyByDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    announcementsByActiveByUrgencyByDate(
      active: $active
      urgencyActivatedAt: $urgencyActivatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        activatedAt
        message
        urgency
        forceRefresh
        link
        tenantId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const apiKeyByKeyId = /* GraphQL */ `
  query ApiKeyByKeyId(
    $keyId: String
    $sortDirection: ModelSortDirection
    $filter: ModelApiKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    apiKeyByKeyId(
      keyId: $keyId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        groups
        reloadYardId
        name
        keyId
        createdBy
        deletedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const apiKeyByActiveByName = /* GraphQL */ `
  query ApiKeyByActiveByName(
    $reloadYardId: ID
    $activeName: ModelApiKeyApiKeyByActiveByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelApiKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    apiKeyByActiveByName(
      reloadYardId: $reloadYardId
      activeName: $activeName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        groups
        reloadYardId
        name
        keyId
        createdBy
        deletedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const areaByActiveBySortKey = /* GraphQL */ `
  query AreaByActiveBySortKey(
    $reloadYardId: ID
    $activeSortKey: ModelAreaAreaByActiveBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    areaByActiveBySortKey(
      reloadYardId: $reloadYardId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const areaBySortKey = /* GraphQL */ `
  query AreaBySortKey(
    $reloadYardId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    areaBySortKey(
      reloadYardId: $reloadYardId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const assetTypeByActiveByName = /* GraphQL */ `
  query AssetTypeByActiveByName(
    $reloadYardId: ID
    $activeName: ModelAssetTypeAssetTypeByActiveByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAssetTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    assetTypeByActiveByName(
      reloadYardId: $reloadYardId
      activeName: $activeName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        maxConcurrentBookings
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const auditByDate = /* GraphQL */ `
  query AuditByDate(
    $reloadYardId: ID
    $createDateTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    auditByDate(
      reloadYardId: $reloadYardId
      createDateTime: $createDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        createdAt
        createDateTime
        notes
        reloadYardId
        processedItems
        processedLocations
        skippedItems
        nextItem
        nextItems {
          locationIdx
          owner
          name
        }
        direction
        accountId
        accountName
        assignedTo
        locations
        startDateTime
        endDateTime
        updatedAt
      }
      nextToken
    }
  }
`;
export const auditByStatusByDate = /* GraphQL */ `
  query AuditByStatusByDate(
    $reloadYardId: ID
    $statusCreateDateTime: ModelAuditAuditByStatusByDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    auditByStatusByDate(
      reloadYardId: $reloadYardId
      statusCreateDateTime: $statusCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        createdAt
        createDateTime
        notes
        reloadYardId
        processedItems
        processedLocations
        skippedItems
        nextItem
        nextItems {
          locationIdx
          owner
          name
        }
        direction
        accountId
        accountName
        assignedTo
        locations
        startDateTime
        endDateTime
        updatedAt
      }
      nextToken
    }
  }
`;
export const barcodeByOwnerByInventoryByLocationByValue = /* GraphQL */ `
  query BarcodeByOwnerByInventoryByLocationByValue(
    $owner: String
    $inventoryIdLocationIdValue: ModelBarcodeBarcodeByOwnerByInventoryByLocationByValueCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBarcodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    barcodeByOwnerByInventoryByLocationByValue(
      owner: $owner
      inventoryIdLocationIdValue: $inventoryIdLocationIdValue
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        value
        isScanned
        scannedIn
        scannedOut
        reloadYardId
        inboundShipmentId
        inventoryId
        locationId
        inventoryItemId
        inventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const barcodeByInventoryByStatusByLocation = /* GraphQL */ `
  query BarcodeByInventoryByStatusByLocation(
    $inventoryId: ID
    $statusLocationId: ModelBarcodeBarcodeByInventoryByStatusByLocationCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBarcodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    barcodeByInventoryByStatusByLocation(
      inventoryId: $inventoryId
      statusLocationId: $statusLocationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        value
        isScanned
        scannedIn
        scannedOut
        reloadYardId
        inboundShipmentId
        inventoryId
        locationId
        inventoryItemId
        inventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const barcodeByInventoryItemByActiveByValue = /* GraphQL */ `
  query BarcodeByInventoryItemByActiveByValue(
    $inventoryItemId: ID
    $activeValue: ModelBarcodeBarcodeByInventoryItemByActiveByValueCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBarcodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    barcodeByInventoryItemByActiveByValue(
      inventoryItemId: $inventoryItemId
      activeValue: $activeValue
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        value
        isScanned
        scannedIn
        scannedOut
        reloadYardId
        inboundShipmentId
        inventoryId
        locationId
        inventoryItemId
        inventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const barcodeByActiveByValue = /* GraphQL */ `
  query BarcodeByActiveByValue(
    $reloadYardId: ID
    $activeValue: ModelBarcodeBarcodeByActiveByValueCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBarcodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    barcodeByActiveByValue(
      reloadYardId: $reloadYardId
      activeValue: $activeValue
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        value
        isScanned
        scannedIn
        scannedOut
        reloadYardId
        inboundShipmentId
        inventoryId
        locationId
        inventoryItemId
        inventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const capabilitiesByActiveBySortKey = /* GraphQL */ `
  query CapabilitiesByActiveBySortKey(
    $active: String
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCapabilityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    capabilitiesByActiveBySortKey(
      active: $active
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        sortKey
        name
        description
        requiresValue
        requiredValueLabel
        quantity
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const carrierByEmail = /* GraphQL */ `
  query CarrierByEmail(
    $reloadYardId: ID
    $email: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    carrierByEmail(
      reloadYardId: $reloadYardId
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const carrierByActiveByName = /* GraphQL */ `
  query CarrierByActiveByName(
    $reloadYardId: ID
    $activeBusinessName: ModelCarrierCarrierByActiveByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    carrierByActiveByName(
      reloadYardId: $reloadYardId
      activeBusinessName: $activeBusinessName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const carrierCompanyByNormalizedEmail = /* GraphQL */ `
  query CarrierCompanyByNormalizedEmail(
    $normalizedEmail: String
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    carrierCompanyByNormalizedEmail(
      normalizedEmail: $normalizedEmail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groups
        businessName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        yards {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const carrierUserByEmail = /* GraphQL */ `
  query CarrierUserByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    carrierUserByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const carrierUserByPhone = /* GraphQL */ `
  query CarrierUserByPhone(
    $phone: String
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    carrierUserByPhone(
      phone: $phone
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const carrierUserByDriverCode = /* GraphQL */ `
  query CarrierUserByDriverCode(
    $driverCode: String
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    carrierUserByDriverCode(
      driverCode: $driverCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        cognitoId
        email
        contactEmail
        unsubscribed
        firstName
        lastName
        phone
        userType
        driverCode
        suspendedAt
        suspendedBy
        suspensionReason
        reloadYardCarriers {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reloadYardCarrierByUser = /* GraphQL */ `
  query ReloadYardCarrierByUser(
    $carrierUserId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierUserReloadYardCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reloadYardCarrierByUser(
      carrierUserId: $carrierUserId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        deleted
        carrierUserId
        user {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        businessName
        firstName
        lastName
        email
        phone
        type
        description
        acl
        photo {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes
        blockAccess
        createdVia
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reloadYardCarrierByCarrierByActive = /* GraphQL */ `
  query ReloadYardCarrierByCarrierByActive(
    $carrierId: ID
    $active: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierUserReloadYardCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reloadYardCarrierByCarrierByActive(
      carrierId: $carrierId
      active: $active
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        deleted
        carrierUserId
        user {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        businessName
        firstName
        lastName
        email
        phone
        type
        description
        acl
        photo {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes
        blockAccess
        createdVia
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reloadYardCarrierByActiveByName = /* GraphQL */ `
  query ReloadYardCarrierByActiveByName(
    $reloadYardId: ID
    $activeBusinessNameLastName: ModelCarrierUserReloadYardCarrierReloadYardCarrierByActiveByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierUserReloadYardCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reloadYardCarrierByActiveByName(
      reloadYardId: $reloadYardId
      activeBusinessNameLastName: $activeBusinessNameLastName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        deleted
        carrierUserId
        user {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        businessName
        firstName
        lastName
        email
        phone
        type
        description
        acl
        photo {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes
        blockAccess
        createdVia
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reloadYardCarrierByActiveByTypeByName = /* GraphQL */ `
  query ReloadYardCarrierByActiveByTypeByName(
    $reloadYardId: ID
    $activeTypeBusinessNameLastName: ModelCarrierUserReloadYardCarrierReloadYardCarrierByActiveByTypeByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCarrierUserReloadYardCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reloadYardCarrierByActiveByTypeByName(
      reloadYardId: $reloadYardId
      activeTypeBusinessNameLastName: $activeTypeBusinessNameLastName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        deleted
        carrierUserId
        user {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        businessName
        firstName
        lastName
        email
        phone
        type
        description
        acl
        photo {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes
        blockAccess
        createdVia
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const rulesByAccountByActiveByEvent = /* GraphQL */ `
  query RulesByAccountByActiveByEvent(
    $accountId: ID
    $activeEvent: ModelChargeRuleRulesByAccountByActiveByEventCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChargeRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rulesByAccountByActiveByEvent(
      accountId: $accountId
      activeEvent: $activeEvent
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        active
        groups
        accountId
        reloadYardId
        event
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        billingUOM
        reloadYardCommodityId
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        graduatedRates {
          days
          rate
        }
        minCharge
        maxCharge
        execution
        frequency
        feeAccrual
        freeDaysPolicy
        freeDays
        freeCars
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const rulesByService = /* GraphQL */ `
  query RulesByService(
    $serviceId: ID
    $activeEvent: ModelChargeRuleRulesByServiceCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChargeRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rulesByService(
      serviceId: $serviceId
      activeEvent: $activeEvent
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        active
        groups
        accountId
        reloadYardId
        event
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        billingUOM
        reloadYardCommodityId
        carrierType
        carrierEquipmentTypeId
        areaId
        zoneId
        graduatedRates {
          days
          rate
        }
        minCharge
        maxCharge
        execution
        frequency
        feeAccrual
        freeDaysPolicy
        freeDays
        freeCars
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const checklistByResourceByProcess = /* GraphQL */ `
  query ChecklistByResourceByProcess(
    $resourceId: ID
    $processName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChecklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    checklistByResourceByProcess(
      resourceId: $resourceId
      processName: $processName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        resourceId
        name
        description
        processName
        checklistItems {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        reloadYardCommodityId
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const commoditiesByActiveByName = /* GraphQL */ `
  query CommoditiesByActiveByName(
    $active: String
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommodityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commoditiesByActiveByName(
      active: $active
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        sortKey
        name
        description
        defaultUnits
        locationLoadType
        validUom
        inventoryFields
        enableCounter
        prompt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const commoditiesByActiveBySortKey = /* GraphQL */ `
  query CommoditiesByActiveBySortKey(
    $active: String
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommodityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commoditiesByActiveBySortKey(
      active: $active
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        sortKey
        name
        description
        defaultUnits
        locationLoadType
        validUom
        inventoryFields
        enableCounter
        prompt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerByEmail = /* GraphQL */ `
  query CustomerByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        cognitoId
        email
        unsubscribed
        firstName
        lastName
        phone
        reloadYardAccounts {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reloadYardAccountByCustomer = /* GraphQL */ `
  query ReloadYardAccountByCustomer(
    $customerId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerReloadYardAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reloadYardAccountByCustomer(
      customerId: $customerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        active
        groups
        email
        lastName
        acl
        description
        customerId
        customer {
          id
          status
          cognitoId
          email
          unsubscribed
          firstName
          lastName
          phone
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        accountId
        accountName
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerByReloadYardByActiveByAccountNameByName = /* GraphQL */ `
  query CustomerByReloadYardByActiveByAccountNameByName(
    $reloadYardId: ID
    $activeAccountNameLastName: ModelCustomerReloadYardAccountCustomerByReloadYardByActiveByAccountNameByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerReloadYardAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByReloadYardByActiveByAccountNameByName(
      reloadYardId: $reloadYardId
      activeAccountNameLastName: $activeAccountNameLastName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        active
        groups
        email
        lastName
        acl
        description
        customerId
        customer {
          id
          status
          cognitoId
          email
          unsubscribed
          firstName
          lastName
          phone
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        accountId
        accountName
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerByAccountByActiveByName = /* GraphQL */ `
  query CustomerByAccountByActiveByName(
    $accountId: ID
    $activeLastName: ModelCustomerReloadYardAccountCustomerByAccountByActiveByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerReloadYardAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByAccountByActiveByName(
      accountId: $accountId
      activeLastName: $activeLastName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        active
        groups
        email
        lastName
        acl
        description
        customerId
        customer {
          id
          status
          cognitoId
          email
          unsubscribed
          firstName
          lastName
          phone
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        accountId
        accountName
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const eventTypeByActiveByAssetType = /* GraphQL */ `
  query EventTypeByActiveByAssetType(
    $reloadYardId: ID
    $activeAssetTypeId: ModelEventTypeEventTypeByActiveByAssetTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventTypeByActiveByAssetType(
      reloadYardId: $reloadYardId
      activeAssetTypeId: $activeAssetTypeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const eventTypeByActiveByArea = /* GraphQL */ `
  query EventTypeByActiveByArea(
    $reloadYardId: ID
    $activeAreaId: ModelEventTypeEventTypeByActiveByAreaCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventTypeByActiveByArea(
      reloadYardId: $reloadYardId
      activeAreaId: $activeAreaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const filesByName = /* GraphQL */ `
  query FilesByName(
    $reloadYardId: ID
    $displayName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    filesByName(
      reloadYardId: $reloadYardId
      displayName: $displayName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        displayName
        rawFileName
        description
        contentDate
        category
        visibility
        file {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const filesByRawName = /* GraphQL */ `
  query FilesByRawName(
    $reloadYardId: ID
    $rawFileName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    filesByRawName(
      reloadYardId: $reloadYardId
      rawFileName: $rawFileName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        displayName
        rawFileName
        description
        contentDate
        category
        visibility
        file {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const helpPageByUrl = /* GraphQL */ `
  query HelpPageByUrl(
    $active: String
    $url: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelHelpPageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    helpPageByUrl(
      active: $active
      url: $url
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        isLive
        url
        topic
        name
        content
        kbFiles {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        kbMedia {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        kbContent {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        updatedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const historyByParentByTime = /* GraphQL */ `
  query HistoryByParentByTime(
    $parentId: ID
    $dateTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelHistoryNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    historyByParentByTime(
      parentId: $parentId
      dateTime: $dateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        parentId
        parentType
        text
        dateTime
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inboundShipmentByAccountByPoNumber = /* GraphQL */ `
  query InboundShipmentByAccountByPoNumber(
    $accountId: ID
    $normalizedPoNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByAccountByPoNumber(
      accountId: $accountId
      normalizedPoNumber: $normalizedPoNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inboundShipmentByStateByRailcar = /* GraphQL */ `
  query InboundShipmentByStateByRailcar(
    $reloadYardId: ID
    $stateRailCarNumber: ModelInboundShipmentInboundShipmentByStateByRailcarCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByStateByRailcar(
      reloadYardId: $reloadYardId
      stateRailCarNumber: $stateRailCarNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inboundShipmentByReloadYardByStatusByDates = /* GraphQL */ `
  query InboundShipmentByReloadYardByStatusByDates(
    $reloadYardId: ID
    $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: ModelInboundShipmentInboundShipmentByReloadYardByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByReloadYardByStatusByDates(
      reloadYardId: $reloadYardId
      statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inboundShipmentByAccountByStatusByDates = /* GraphQL */ `
  query InboundShipmentByAccountByStatusByDates(
    $accountId: ID
    $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: ModelInboundShipmentInboundShipmentByAccountByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByAccountByStatusByDates(
      accountId: $accountId
      statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inboundShipmentByReloadYardByInvoice = /* GraphQL */ `
  query InboundShipmentByReloadYardByInvoice(
    $reloadYardId: ID
    $invoiceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByReloadYardByInvoice(
      reloadYardId: $reloadYardId
      invoiceId: $invoiceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inboundShipmentByReloadYardByAccount = /* GraphQL */ `
  query InboundShipmentByReloadYardByAccount(
    $reloadYardId: ID
    $accountId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByReloadYardByAccount(
      reloadYardId: $reloadYardId
      accountId: $accountId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inboundShipmentByCarrierByStatusByDates = /* GraphQL */ `
  query InboundShipmentByCarrierByStatusByDates(
    $carrierId: ID
    $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: ModelInboundShipmentInboundShipmentByCarrierByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByCarrierByStatusByDates(
      carrierId: $carrierId
      statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryByWorkOrderBySortKey = /* GraphQL */ `
  query InventoryByWorkOrderBySortKey(
    $workOrderId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByWorkOrderBySortKey(
      workOrderId: $workOrderId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryByStatusByLot = /* GraphQL */ `
  query InventoryByStatusByLot(
    $reloadYardId: ID
    $statusLotNumber: ModelInventoryInventoryByStatusByLotCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByStatusByLot(
      reloadYardId: $reloadYardId
      statusLotNumber: $statusLotNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryByStatusByAccountByProductByLot = /* GraphQL */ `
  query InventoryByStatusByAccountByProductByLot(
    $reloadYardId: ID
    $statusAccountNameProductNameLotNumber: ModelInventoryInventoryByStatusByAccountByProductByLotCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByStatusByAccountByProductByLot(
      reloadYardId: $reloadYardId
      statusAccountNameProductNameLotNumber: $statusAccountNameProductNameLotNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryByStatusByAccountIdByProductByLot = /* GraphQL */ `
  query InventoryByStatusByAccountIdByProductByLot(
    $reloadYardId: ID
    $statusAccountIdProductNameLotNumber: ModelInventoryInventoryByStatusByAccountIdByProductByLotCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByStatusByAccountIdByProductByLot(
      reloadYardId: $reloadYardId
      statusAccountIdProductNameLotNumber: $statusAccountIdProductNameLotNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryByAreaByProductByStatus = /* GraphQL */ `
  query InventoryByAreaByProductByStatus(
    $areaId: ID
    $productIdStatus: ModelInventoryInventoryByAreaByProductByStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByAreaByProductByStatus(
      areaId: $areaId
      productIdStatus: $productIdStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryByProductByStatus = /* GraphQL */ `
  query InventoryByProductByStatus(
    $reloadYardId: ID
    $productIdStatus: ModelInventoryInventoryByProductByStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByProductByStatus(
      reloadYardId: $reloadYardId
      productIdStatus: $productIdStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryByInboundShipmentBySortKey = /* GraphQL */ `
  query InventoryByInboundShipmentBySortKey(
    $inboundShipmentId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByInboundShipmentBySortKey(
      inboundShipmentId: $inboundShipmentId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryByInboundShipmentByProduct = /* GraphQL */ `
  query InventoryByInboundShipmentByProduct(
    $inboundShipmentId: ID
    $productName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByInboundShipmentByProduct(
      inboundShipmentId: $inboundShipmentId
      productName: $productName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryItemByInboundByStatus = /* GraphQL */ `
  query InventoryItemByInboundByStatus(
    $inboundShipmentId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByInboundByStatus(
      inboundShipmentId: $inboundShipmentId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryItemByAreaByStatus = /* GraphQL */ `
  query InventoryItemByAreaByStatus(
    $areaId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByAreaByStatus(
      areaId: $areaId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryItemByZoneByStatus = /* GraphQL */ `
  query InventoryItemByZoneByStatus(
    $zoneId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByZoneByStatus(
      zoneId: $zoneId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryItemByAisleByStatus = /* GraphQL */ `
  query InventoryItemByAisleByStatus(
    $aisleId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByAisleByStatus(
      aisleId: $aisleId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryItemByLocationByStatus = /* GraphQL */ `
  query InventoryItemByLocationByStatus(
    $locationId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByLocationByStatus(
      locationId: $locationId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryItemByInventoryByStatus = /* GraphQL */ `
  query InventoryItemByInventoryByStatus(
    $inventoryId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByInventoryByStatus(
      inventoryId: $inventoryId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const invoiceByExternalId = /* GraphQL */ `
  query InvoiceByExternalId(
    $reloadYardId: ID
    $externalId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByExternalId(
      reloadYardId: $reloadYardId
      externalId: $externalId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const invoiceByAccountByActiveByStatusByDate = /* GraphQL */ `
  query InvoiceByAccountByActiveByStatusByDate(
    $accountId: ID
    $activeStatusDueDate: ModelInvoiceInvoiceByAccountByActiveByStatusByDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByAccountByActiveByStatusByDate(
      accountId: $accountId
      activeStatusDueDate: $activeStatusDueDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const invoiceByActiveByStatusByDateByAccount = /* GraphQL */ `
  query InvoiceByActiveByStatusByDateByAccount(
    $reloadYardId: ID
    $activeStatusDueDateAccountName: ModelInvoiceInvoiceByActiveByStatusByDateByAccountCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByActiveByStatusByDateByAccount(
      reloadYardId: $reloadYardId
      activeStatusDueDateAccountName: $activeStatusDueDateAccountName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const invoiceServiceBySortKey = /* GraphQL */ `
  query InvoiceServiceBySortKey(
    $invoiceId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceServiceBySortKey(
      invoiceId: $invoiceId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        event
        externalId
        sortKey
        accountId
        reloadYardId
        inboundShipmentId
        outboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        quantity
        units
        unitCost
        amount
        itemTax
        taxRate {
          taxCode
          name
          taxRate
        }
        itemTotal
        serviceNote
        serviceDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const invoiceServiceByInbound = /* GraphQL */ `
  query InvoiceServiceByInbound(
    $inboundShipmentId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceServiceByInbound(
      inboundShipmentId: $inboundShipmentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        event
        externalId
        sortKey
        accountId
        reloadYardId
        inboundShipmentId
        outboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        quantity
        units
        unitCost
        amount
        itemTax
        taxRate {
          taxCode
          name
          taxRate
        }
        itemTotal
        serviceNote
        serviceDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const invoiceServiceByOutbound = /* GraphQL */ `
  query InvoiceServiceByOutbound(
    $outboundShipmentId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceServiceByOutbound(
      outboundShipmentId: $outboundShipmentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        event
        externalId
        sortKey
        accountId
        reloadYardId
        inboundShipmentId
        outboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        quantity
        units
        unitCost
        amount
        itemTax
        taxRate {
          taxCode
          name
          taxRate
        }
        itemTotal
        serviceNote
        serviceDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const invoiceServiceByService = /* GraphQL */ `
  query InvoiceServiceByService(
    $serviceId: ID
    $invoiceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceServiceByService(
      serviceId: $serviceId
      invoiceId: $invoiceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        event
        externalId
        sortKey
        accountId
        reloadYardId
        inboundShipmentId
        outboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        quantity
        units
        unitCost
        amount
        itemTax
        taxRate {
          taxCode
          name
          taxRate
        }
        itemTotal
        serviceNote
        serviceDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const locationBySortKey = /* GraphQL */ `
  query LocationBySortKey(
    $reloadYardId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationBySortKey(
      reloadYardId: $reloadYardId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const locationByAreaBySortKey = /* GraphQL */ `
  query LocationByAreaBySortKey(
    $reloadYardId: ID
    $areaIdSortKey: ModelLocationLocationByAreaBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByAreaBySortKey(
      reloadYardId: $reloadYardId
      areaIdSortKey: $areaIdSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const locationByZoneBySortKey = /* GraphQL */ `
  query LocationByZoneBySortKey(
    $reloadYardId: ID
    $zoneIdSortKey: ModelLocationLocationByZoneBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByZoneBySortKey(
      reloadYardId: $reloadYardId
      zoneIdSortKey: $zoneIdSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const locationByProductBySortKey = /* GraphQL */ `
  query LocationByProductBySortKey(
    $reloadYardId: ID
    $productIdSortKey: ModelLocationLocationByProductBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByProductBySortKey(
      reloadYardId: $reloadYardId
      productIdSortKey: $productIdSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const locationByAisleByActiveBySortKey = /* GraphQL */ `
  query LocationByAisleByActiveBySortKey(
    $aisleId: ID
    $activeSortKey: ModelLocationLocationByAisleByActiveBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByAisleByActiveBySortKey(
      aisleId: $aisleId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const locationByAisleBySortKey = /* GraphQL */ `
  query LocationByAisleBySortKey(
    $aisleId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByAisleBySortKey(
      aisleId: $aisleId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        containerNumber
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const locationTagByLocationId = /* GraphQL */ `
  query LocationTagByLocationId(
    $locationId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLocationTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationTagByLocationId(
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        tagId
        tag {
          id
          owner
          groups
          reloadYardId
          name
          description
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const locationTagByTagId = /* GraphQL */ `
  query LocationTagByTagId(
    $tagId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLocationTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationTagByTagId(
      tagId: $tagId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        tagId
        tag {
          id
          owner
          groups
          reloadYardId
          name
          description
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const logByDateByUser = /* GraphQL */ `
  query LogByDateByUser(
    $tenantId: String
    $createdAtUser: ModelLogLogByDateByUserCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logByDateByUser(
      tenantId: $tenantId
      createdAtUser: $createdAtUser
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        createdAt
        appType
        tenantId
        user
        message
        exception
        appVersion
        url
        context
        owner
        updatedAt
      }
      nextToken
    }
  }
`;
export const logByDateByTenant = /* GraphQL */ `
  query LogByDateByTenant(
    $status: String
    $createdAtTenantId: ModelLogLogByDateByTenantCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logByDateByTenant(
      status: $status
      createdAtTenantId: $createdAtTenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        createdAt
        appType
        tenantId
        user
        message
        exception
        appVersion
        url
        context
        owner
        updatedAt
      }
      nextToken
    }
  }
`;
export const outboundShipmentByAccountByPoNumber = /* GraphQL */ `
  query OutboundShipmentByAccountByPoNumber(
    $accountId: ID
    $normalizedPoNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByAccountByPoNumber(
      accountId: $accountId
      normalizedPoNumber: $normalizedPoNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const outboundShipmentByAccountByPickupNumber = /* GraphQL */ `
  query OutboundShipmentByAccountByPickupNumber(
    $accountId: ID
    $normalizedPickupNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByAccountByPickupNumber(
      accountId: $accountId
      normalizedPickupNumber: $normalizedPickupNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const outboundShipmentByAccountByConsigneePoNumber = /* GraphQL */ `
  query OutboundShipmentByAccountByConsigneePoNumber(
    $accountId: ID
    $normalizedConsigneePoNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByAccountByConsigneePoNumber(
      accountId: $accountId
      normalizedConsigneePoNumber: $normalizedConsigneePoNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const outboundShipmentByStatus = /* GraphQL */ `
  query OutboundShipmentByStatus(
    $reloadYardId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByStatus(
      reloadYardId: $reloadYardId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const outboundShipmentByStatusByActive = /* GraphQL */ `
  query OutboundShipmentByStatusByActive(
    $reloadYardId: ID
    $statusActive: ModelOutboundShipmentOutboundShipmentByStatusByActiveCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByStatusByActive(
      reloadYardId: $reloadYardId
      statusActive: $statusActive
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const outboundShipmentByReloadYardByInvoice = /* GraphQL */ `
  query OutboundShipmentByReloadYardByInvoice(
    $reloadYardId: ID
    $invoiceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByReloadYardByInvoice(
      reloadYardId: $reloadYardId
      invoiceId: $invoiceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const outboundShipmentByReloadYardByStatusByDates = /* GraphQL */ `
  query OutboundShipmentByReloadYardByStatusByDates(
    $reloadYardId: ID
    $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: ModelOutboundShipmentOutboundShipmentByReloadYardByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByReloadYardByStatusByDates(
      reloadYardId: $reloadYardId
      statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const outboundShipmentByAccountByStatusByDates = /* GraphQL */ `
  query OutboundShipmentByAccountByStatusByDates(
    $accountId: ID
    $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: ModelOutboundShipmentOutboundShipmentByAccountByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByAccountByStatusByDates(
      accountId: $accountId
      statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const outboundShipmentByCarrierByStatusByDates = /* GraphQL */ `
  query OutboundShipmentByCarrierByStatusByDates(
    $carrierId: ID
    $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: ModelOutboundShipmentOutboundShipmentByCarrierByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByCarrierByStatusByDates(
      carrierId: $carrierId
      statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: $statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const paymentTermBySortKey = /* GraphQL */ `
  query PaymentTermBySortKey(
    $reloadYardId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentTermFilterInput
    $limit: Int
    $nextToken: String
  ) {
    paymentTermBySortKey(
      reloadYardId: $reloadYardId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const photoByParentByTime = /* GraphQL */ `
  query PhotoByParentByTime(
    $parentId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPhotoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    photoByParentByTime(
      parentId: $parentId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        parentId
        parentType
        bucket
        region
        key
        type
        name
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const productByAccountByActiveByProductCode = /* GraphQL */ `
  query ProductByAccountByActiveByProductCode(
    $accountId: ID
    $activeProductCode: ModelProductProductByAccountByActiveByProductCodeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productByAccountByActiveByProductCode(
      accountId: $accountId
      activeProductCode: $activeProductCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const productByAccountByActiveByName = /* GraphQL */ `
  query ProductByAccountByActiveByName(
    $accountId: ID
    $activeName: ModelProductProductByAccountByActiveByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productByAccountByActiveByName(
      accountId: $accountId
      activeName: $activeName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const productStatsByProduct = /* GraphQL */ `
  query ProductStatsByProduct(
    $productId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productStatsByProduct(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        stats
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const productStatsByAccount = /* GraphQL */ `
  query ProductStatsByAccount(
    $accountId: ID
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productStatsByAccount(
      accountId: $accountId
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        stats
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const railEquipmentTypeByActive = /* GraphQL */ `
  query RailEquipmentTypeByActive(
    $reloadYardId: ID
    $active: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRailEquipmentTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    railEquipmentTypeByActive(
      reloadYardId: $reloadYardId
      active: $active
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const railEquipmentTypeByActiveBySortKey = /* GraphQL */ `
  query RailEquipmentTypeByActiveBySortKey(
    $reloadYardId: ID
    $activeSortKey: ModelRailEquipmentTypeRailEquipmentTypeByActiveBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRailEquipmentTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    railEquipmentTypeByActiveBySortKey(
      reloadYardId: $reloadYardId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        name
        arrTypeCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const rawDataBySessionId = /* GraphQL */ `
  query RawDataBySessionId(
    $reloadYardId: ID
    $braSessionId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRawDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rawDataBySessionId(
      reloadYardId: $reloadYardId
      braSessionId: $braSessionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        accountId
        braSessionId
        braRawData
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reloadYardByName = /* GraphQL */ `
  query ReloadYardByName(
    $active: String
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReloadYardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reloadYardByName(
      active: $active
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reloadYardCapabilityByReloadYard = /* GraphQL */ `
  query ReloadYardCapabilityByReloadYard(
    $reloadYardId: ID
    $active: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReloadYardCapabilityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reloadYardCapabilityByReloadYard(
      reloadYardId: $reloadYardId
      active: $active
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        capabilityId
        owner
        groups
        active
        verified
        requiredValue
        capability {
          id
          active
          sortKey
          name
          description
          requiresValue
          requiredValueLabel
          quantity
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reloadYardCapabilityByCapability = /* GraphQL */ `
  query ReloadYardCapabilityByCapability(
    $reloadYardId: ID
    $capabilityIdActive: ModelReloadYardCapabilityReloadYardCapabilityByCapabilityCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReloadYardCapabilityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reloadYardCapabilityByCapability(
      reloadYardId: $reloadYardId
      capabilityIdActive: $capabilityIdActive
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        capabilityId
        owner
        groups
        active
        verified
        requiredValue
        capability {
          id
          active
          sortKey
          name
          description
          requiresValue
          requiredValueLabel
          quantity
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reloadYardCommodityByActiveBySortKey = /* GraphQL */ `
  query ReloadYardCommodityByActiveBySortKey(
    $reloadYardId: ID
    $activeSortKey: ModelReloadYardCommodityReloadYardCommodityByActiveBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReloadYardCommodityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reloadYardCommodityByActiveBySortKey(
      reloadYardId: $reloadYardId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reloadYardCommodityByCommodity = /* GraphQL */ `
  query ReloadYardCommodityByCommodity(
    $reloadYardId: ID
    $commodityIdActive: ModelReloadYardCommodityReloadYardCommodityByCommodityCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReloadYardCommodityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reloadYardCommodityByCommodity(
      reloadYardId: $reloadYardId
      commodityIdActive: $commodityIdActive
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        showCounter
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          validUom
          inventoryFields
          enableCounter
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const addressByAccountByNameByStreet = /* GraphQL */ `
  query AddressByAccountByNameByStreet(
    $accountId: ID
    $nameStreet: ModelSavedAddressAddressByAccountByNameByStreetCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSavedAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    addressByAccountByNameByStreet(
      accountId: $accountId
      nameStreet: $nameStreet
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        accountId
        name
        street
        city
        state
        zipCode
        country
        phone
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const sealByReferenceId = /* GraphQL */ `
  query SealByReferenceId(
    $referenceId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelSealFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sealByReferenceId(
      referenceId: $referenceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        owner
        groups
        reloadYardId
        accountId
        accountName
        referenceId
        referenceName
        barcode
        isScanned
        createdAt
        createdBy
        validated
        reValidated
        brokenAt
        brokenBy
        description
        status
        updatedAt
      }
      nextToken
    }
  }
`;
export const serviceByAccountByStatusByName = /* GraphQL */ `
  query ServiceByAccountByStatusByName(
    $accountId: ID
    $statusName: ModelServiceServiceByAccountByStatusByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceByAccountByStatusByName(
      accountId: $accountId
      statusName: $statusName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const serviceByAccountByActiveByName = /* GraphQL */ `
  query ServiceByAccountByActiveByName(
    $accountId: ID
    $activeName: ModelServiceServiceByAccountByActiveByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceByAccountByActiveByName(
      accountId: $accountId
      activeName: $activeName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        reloadYardId
        accountName
        accountId
        name
        description
        taxRate {
          taxCode
          name
          taxRate
        }
        unit
        pcs
        car
        tl
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const setupDataByStatusBySubmitDate = /* GraphQL */ `
  query SetupDataByStatusBySubmitDate(
    $status: Int
    $submitDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSetupDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    setupDataByStatusBySubmitDate(
      status: $status
      submitDate: $submitDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        status
        cognitoId
        firstName
        lastName
        businessName
        setupData
        submitDate
        approvalDate
        approvedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const setupDataByCognitoIdByStatus = /* GraphQL */ `
  query SetupDataByCognitoIdByStatus(
    $cognitoId: String
    $status: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSetupDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    setupDataByCognitoIdByStatus(
      cognitoId: $cognitoId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        status
        cognitoId
        firstName
        lastName
        businessName
        setupData
        submitDate
        approvalDate
        approvedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const shipmentLineItemByOutboundShipmentBySortKey = /* GraphQL */ `
  query ShipmentLineItemByOutboundShipmentBySortKey(
    $outboundShipmentId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentLineItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentLineItemByOutboundShipmentBySortKey(
      outboundShipmentId: $outboundShipmentId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        sortKey
        lotNumber
        poNumber
        totalQuantityToPick
        totalQuantityReturned
        units
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        pickupPhoto {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        inventoryItems {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const shipmentLineItemByInventory = /* GraphQL */ `
  query ShipmentLineItemByInventory(
    $inventoryId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentLineItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentLineItemByInventory(
      inventoryId: $inventoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        sortKey
        lotNumber
        poNumber
        totalQuantityToPick
        totalQuantityReturned
        units
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        pickupPhoto {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        inventoryItems {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const SLIIIByOutboundByStatus = /* GraphQL */ `
  query SLIIIByOutboundByStatus(
    $outboundShipmentId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentLineItemInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    SLIIIByOutboundByStatus(
      outboundShipmentId: $outboundShipmentId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        outboundShipmentId
        shipmentLineItemId
        inventoryId
        inventoryItemId
        inventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        quantityToPick
        quantityReturned
        scannedOut
        loadedBy
        units
        status
        hasException
        barcodeException
        barcodeExceptionNote
        otherException
        otherExceptionNote
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const shipmentLineItemByInventoryItem = /* GraphQL */ `
  query ShipmentLineItemByInventoryItem(
    $inventoryItemId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentLineItemInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentLineItemByInventoryItem(
      inventoryItemId: $inventoryItemId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        outboundShipmentId
        shipmentLineItemId
        inventoryId
        inventoryItemId
        inventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        quantityToPick
        quantityReturned
        scannedOut
        loadedBy
        units
        status
        hasException
        barcodeException
        barcodeExceptionNote
        otherException
        otherExceptionNote
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const inventoryItemByShipmentLineItem = /* GraphQL */ `
  query InventoryItemByShipmentLineItem(
    $shipmentLineItemId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentLineItemInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByShipmentLineItem(
      shipmentLineItemId: $shipmentLineItemId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        outboundShipmentId
        shipmentLineItemId
        inventoryId
        inventoryItemId
        inventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        quantityToPick
        quantityReturned
        scannedOut
        loadedBy
        units
        status
        hasException
        barcodeException
        barcodeExceptionNote
        otherException
        otherExceptionNote
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const supportRequestByStatusByCreatedAt = /* GraphQL */ `
  query SupportRequestByStatusByCreatedAt(
    $status: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSupportRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    supportRequestByStatusByCreatedAt(
      status: $status
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        reloadYardId
        subject
        description
        requirements
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        submittedAt
        approvedPriceCents
        maxRevisions
        approvedBy
        approvedAt
        quoteExpiresAt
        estimatedDays
        stripeCheckoutSessionId
        stripePaymentIntentId
        stripePaymentStatus
        paidAt
        startedAt
        deliveredAt
        revisionCount
        deliveryNotes
        deliveryAttachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const supportRequestByReloadYardByStatusByCreatedAt = /* GraphQL */ `
  query SupportRequestByReloadYardByStatusByCreatedAt(
    $reloadYardId: ID
    $statusCreatedAt: ModelSupportRequestSupportRequestByReloadYardByStatusByCreatedAtCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSupportRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    supportRequestByReloadYardByStatusByCreatedAt(
      reloadYardId: $reloadYardId
      statusCreatedAt: $statusCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        reloadYardId
        subject
        description
        requirements
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        submittedAt
        approvedPriceCents
        maxRevisions
        approvedBy
        approvedAt
        quoteExpiresAt
        estimatedDays
        stripeCheckoutSessionId
        stripePaymentIntentId
        stripePaymentStatus
        paidAt
        startedAt
        deliveredAt
        revisionCount
        deliveryNotes
        deliveryAttachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const TagsByName = /* GraphQL */ `
  query TagsByName(
    $reloadYardId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    TagsByName(
      reloadYardId: $reloadYardId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        name
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const taskByReference = /* GraphQL */ `
  query TaskByReference(
    $reference: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taskByReference(
      reference: $reference
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        status
        reloadYardId
        createdAt
        updatedAt
        name
        description
        assignedTo
        assignedToName
        allowReassign
        link
        priority
        reference
        category
        dueDate
        lateDate
        completedBy
        completedDate
        resolvedDate
        resolvedBy
        note
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const taskByStatusByAssignedTo = /* GraphQL */ `
  query TaskByStatusByAssignedTo(
    $reloadYardId: ID
    $statusAssignedToName: ModelTaskTaskByStatusByAssignedToCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taskByStatusByAssignedTo(
      reloadYardId: $reloadYardId
      statusAssignedToName: $statusAssignedToName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        status
        reloadYardId
        createdAt
        updatedAt
        name
        description
        assignedTo
        assignedToName
        allowReassign
        link
        priority
        reference
        category
        dueDate
        lateDate
        completedBy
        completedDate
        resolvedDate
        resolvedBy
        note
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const taskByAssignedToByStatusByDueDate = /* GraphQL */ `
  query TaskByAssignedToByStatusByDueDate(
    $assignedTo: ID
    $statusDueDate: ModelTaskTaskByAssignedToByStatusByDueDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taskByAssignedToByStatusByDueDate(
      assignedTo: $assignedTo
      statusDueDate: $statusDueDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        status
        reloadYardId
        createdAt
        updatedAt
        name
        description
        assignedTo
        assignedToName
        allowReassign
        link
        priority
        reference
        category
        dueDate
        lateDate
        completedBy
        completedDate
        resolvedDate
        resolvedBy
        note
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const timeslotByYearByWeek = /* GraphQL */ `
  query TimeslotByYearByWeek(
    $reloadYardId: ID
    $yearWeek: ModelTimeslotTimeslotByYearByWeekCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeslotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeslotByYearByWeek(
      reloadYardId: $reloadYardId
      yearWeek: $yearWeek
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const timeslotByEventTypeByDateByTime = /* GraphQL */ `
  query TimeslotByEventTypeByDateByTime(
    $eventTypeId: ID
    $yearMonthDayTime: ModelTimeslotTimeslotByEventTypeByDateByTimeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeslotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeslotByEventTypeByDateByTime(
      eventTypeId: $eventTypeId
      yearMonthDayTime: $yearMonthDayTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          workflow
          reloadYardCommodityId
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        carrierUserId
        carrierUser {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const trackCarByActiveByTrackBySortKey = /* GraphQL */ `
  query TrackCarByActiveByTrackBySortKey(
    $reloadYardId: ID
    $activeTrackIdSortKey: ModelTrackCarTrackCarByActiveByTrackBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTrackCarFilterInput
    $limit: Int
    $nextToken: String
  ) {
    trackCarByActiveByTrackBySortKey(
      reloadYardId: $reloadYardId
      activeTrackIdSortKey: $activeTrackIdSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      nextToken
    }
  }
`;
export const trackCarByActiveByTrackByEodSortKey = /* GraphQL */ `
  query TrackCarByActiveByTrackByEodSortKey(
    $reloadYardId: ID
    $activeEodTrackIdEodSortKey: ModelTrackCarTrackCarByActiveByEodTrackByEodSortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTrackCarFilterInput
    $limit: Int
    $nextToken: String
  ) {
    trackCarByActiveByTrackByEodSortKey(
      reloadYardId: $reloadYardId
      activeEodTrackIdEodSortKey: $activeEodTrackIdEodSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        owner
        areaId
        zoneId
        aisleId
        trackId
        eodTrackId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        locationFullName
        reloadYardId
        accountId
        shipmentId
        parentType
        inbound {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outbound {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        railCarNumber
        sortKey
        eodSortKey
        movementLogs {
          trackCarId
          sortKey
          movedAt
          movedBy
        }
        updatedAt
        updatedBy
        createdAt
      }
      nextToken
    }
  }
`;
export const truckEquipmentTypeByActive = /* GraphQL */ `
  query TruckEquipmentTypeByActive(
    $reloadYardId: ID
    $active: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTruckEquipmentTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    truckEquipmentTypeByActive(
      reloadYardId: $reloadYardId
      active: $active
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const truckEquipmentTypeByActiveBySortKey = /* GraphQL */ `
  query TruckEquipmentTypeByActiveBySortKey(
    $reloadYardId: ID
    $activeSortKey: ModelTruckEquipmentTypeTruckEquipmentTypeByActiveBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTruckEquipmentTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    truckEquipmentTypeByActiveBySortKey(
      reloadYardId: $reloadYardId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        name
        dotSpecCode
        dotClassCode
        length
        reloadYardId
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const userByEmail = /* GraphQL */ `
  query UserByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        cognitoId
        type
        firstName
        lastName
        fullName
        phone
        email
        unsubscribed
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        reloadYardId
        acl
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const userByActiveByLastName = /* GraphQL */ `
  query UserByActiveByLastName(
    $reloadYardId: ID
    $activeLastName: ModelUserUserByActiveByLastNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByActiveByLastName(
      reloadYardId: $reloadYardId
      activeLastName: $activeLastName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        cognitoId
        type
        firstName
        lastName
        fullName
        phone
        email
        unsubscribed
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        reloadYardId
        acl
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const workChargeRuleByParent = /* GraphQL */ `
  query WorkChargeRuleByParent(
    $parentId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWorkChargeRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workChargeRuleByParent(
      parentId: $parentId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        parentId
        parentType
        chargeRuleId
        chargeRule {
          id
          owner
          active
          groups
          accountId
          reloadYardId
          event
          serviceId
          billingUOM
          reloadYardCommodityId
          carrierType
          carrierEquipmentTypeId
          areaId
          zoneId
          minCharge
          maxCharge
          execution
          frequency
          feeAccrual
          freeDaysPolicy
          freeDays
          freeCars
          createdAt
          updatedAt
        }
        quantity
        sortKey
        invoiceServiceId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const workOrderByState = /* GraphQL */ `
  query WorkOrderByState(
    $reloadYardId: ID
    $state: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWorkOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workOrderByState(
      reloadYardId: $reloadYardId
      state: $state
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const workOrderByReloadYardByStatusByDates = /* GraphQL */ `
  query WorkOrderByReloadYardByStatusByDates(
    $reloadYardId: ID
    $statusEndDateTimeStartDateTimeCreateDateTime: ModelWorkOrderWorkOrderByReloadYardByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWorkOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workOrderByReloadYardByStatusByDates(
      reloadYardId: $reloadYardId
      statusEndDateTimeStartDateTimeCreateDateTime: $statusEndDateTimeStartDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const workOrderByAccountByStatusByDates = /* GraphQL */ `
  query WorkOrderByAccountByStatusByDates(
    $accountId: ID
    $statusEndDateTimeStartDateTimeCreateDateTime: ModelWorkOrderWorkOrderByAccountByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWorkOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workOrderByAccountByStatusByDates(
      accountId: $accountId
      statusEndDateTimeStartDateTimeCreateDateTime: $statusEndDateTimeStartDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const workOrderByReloadYardByInvoice = /* GraphQL */ `
  query WorkOrderByReloadYardByInvoice(
    $reloadYardId: ID
    $invoiceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWorkOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workOrderByReloadYardByInvoice(
      reloadYardId: $reloadYardId
      invoiceId: $invoiceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const workOrderItemByWorkOrderBySortKey = /* GraphQL */ `
  query WorkOrderItemByWorkOrderBySortKey(
    $workOrderId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWorkOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workOrderItemByWorkOrderBySortKey(
      workOrderId: $workOrderId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        workOrderId
        sortKey
        poNumber
        quantityToProcess
        units
        history {
          type
          date
          by
          text
          public
        }
        accountId
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        inputInventoryItemId
        inputInventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const workOrderItemByInputInventory = /* GraphQL */ `
  query WorkOrderItemByInputInventory(
    $inputInventoryId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelWorkOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workOrderItemByInputInventory(
      inputInventoryId: $inputInventoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        workOrderId
        sortKey
        poNumber
        quantityToProcess
        units
        history {
          type
          date
          by
          text
          public
        }
        accountId
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        inputInventoryItemId
        inputInventoryItem {
          id
          owner
          groups
          quantityOnHand
          altQuantityOnHand
          quantityCommitted
          altQuantityCommitted
          pcsOnHand
          pcsCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          accountId
          inboundShipmentId
          inventoryId
          barcode
          areaId
          zoneId
          aisleId
          locationId
          outboundShipmentId
          locationFullName
          latitude
          longitude
          reloadYardId
          unloadedAt
          unloadedBy
          depletedAt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const zapByActiveByEvent = /* GraphQL */ `
  query ZapByActiveByEvent(
    $reloadYardId: ID
    $activeEvent: ModelZapierHookZapByActiveByEventCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelZapierHookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    zapByActiveByEvent(
      reloadYardId: $reloadYardId
      activeEvent: $activeEvent
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groups
        active
        reloadYardId
        event
        zapId
        url
        link
        options
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const actionByActiveByEvent = /* GraphQL */ `
  query ActionByActiveByEvent(
    $reloadYardId: ID
    $activeEvent: ModelZapierActionActionByActiveByEventCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelZapierActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    actionByActiveByEvent(
      reloadYardId: $reloadYardId
      activeEvent: $activeEvent
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groups
        active
        reloadYardId
        event
        name
        description
        counter
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const zoneBySortKey = /* GraphQL */ `
  query ZoneBySortKey(
    $reloadYardId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelZoneFilterInput
    $limit: Int
    $nextToken: String
  ) {
    zoneBySortKey(
      reloadYardId: $reloadYardId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const zoneByAreaBySortKey = /* GraphQL */ `
  query ZoneByAreaBySortKey(
    $areaId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelZoneFilterInput
    $limit: Int
    $nextToken: String
  ) {
    zoneByAreaBySortKey(
      areaId: $areaId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        leasedArea
        leasedAreaUOM
        areaId
        aisles {
          nextToken
        }
        color
        zoneType
        reloadYardCommodityId
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const driverSessionByYard = /* GraphQL */ `
  query DriverSessionByYard(
    $reloadYardId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDriverSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    driverSessionByYard(
      reloadYardId: $reloadYardId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        carrierUserId
        gateCheckInId
        ip
        userAgent
        windowStart
        searchCount
        identifyCount
        enrollCount
        captureCount
        revoked
        expiresAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const driverSessionByIp = /* GraphQL */ `
  query DriverSessionByIp(
    $ip: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDriverSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    driverSessionByIp(
      ip: $ip
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        carrierUserId
        gateCheckInId
        ip
        userAgent
        windowStart
        searchCount
        identifyCount
        enrollCount
        captureCount
        revoked
        expiresAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const gateCheckInByYardByStatus = /* GraphQL */ `
  query GateCheckInByYardByStatus(
    $reloadYardId: ID
    $statusArrivedAt: ModelGateCheckInGateCheckInByYardByStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGateCheckInFilterInput
    $limit: Int
    $nextToken: String
  ) {
    gateCheckInByYardByStatus(
      reloadYardId: $reloadYardId
      statusArrivedAt: $statusArrivedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        driverSessionId
        carrierUserId
        carrierId
        carrierName
        driverName
        shipmentKey
        inboundId
        outboundId
        timeslotId
        scheduledDateTime
        referenceEntered
        driverNameEntered
        truckPlate
        trailerNumber
        latitude
        longitude
        locationAccuracy
        status
        dockAssignment
        arrivedAt
        calledAt
        completedAt
        updatedBy
        outboundIds
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const gateCheckInByShipment = /* GraphQL */ `
  query GateCheckInByShipment(
    $shipmentKey: String
    $sortDirection: ModelSortDirection
    $filter: ModelGateCheckInFilterInput
    $limit: Int
    $nextToken: String
  ) {
    gateCheckInByShipment(
      shipmentKey: $shipmentKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        driverSessionId
        carrierUserId
        carrierId
        carrierName
        driverName
        shipmentKey
        inboundId
        outboundId
        timeslotId
        scheduledDateTime
        referenceEntered
        driverNameEntered
        truckPlate
        trailerNumber
        latitude
        longitude
        locationAccuracy
        status
        dockAssignment
        arrivedAt
        calledAt
        completedAt
        updatedBy
        outboundIds
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const gateCheckInByDriver = /* GraphQL */ `
  query GateCheckInByDriver(
    $carrierUserId: ID
    $arrivedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGateCheckInFilterInput
    $limit: Int
    $nextToken: String
  ) {
    gateCheckInByDriver(
      carrierUserId: $carrierUserId
      arrivedAt: $arrivedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        reloadYardId
        driverSessionId
        carrierUserId
        carrierId
        carrierName
        driverName
        shipmentKey
        inboundId
        outboundId
        timeslotId
        scheduledDateTime
        referenceEntered
        driverNameEntered
        truckPlate
        trailerNumber
        latitude
        longitude
        locationAccuracy
        status
        dockAssignment
        arrivedAt
        calledAt
        completedAt
        updatedBy
        outboundIds
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const searchAccounts = /* GraphQL */ `
  query SearchAccounts(
    $filter: SearchableAccountFilterInput
    $sort: SearchableAccountSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchAccounts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        status
        businessName
        displayName
        accountNumber
        externalId
        externalStatus
        accountType
        defaultBillToAccountId
        lotNumberPrefix
        color
        defaultWeightUOM
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        creditLimit
        overLimit
        overDue
        einNumber
        skipInvoice
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
          required
        }
        addressState
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        secondaryReview
        inboundSkipSignature
        inboundPhotos
        podEmail
        podPhotos
        podAttachments
        podSubject
        inboundAdviceInputs
        inboundEventTypeId
        lotType
        lotNumberOverride
        fifoLotNumber
        carlotLotNumber
        verifyInboundRailCar
        trackInboundSeals
        requireDefaultZone
        outboundCustomFields {
          id
          name
          type
          display
          required
        }
        outboundInstructions
        posEmail
        posPhotos
        posAttachments
        posSubject
        outboundSkipSignature
        outboundPhotos
        outboundReview
        outboundAdviceInputs
        outboundEventTypeId
        generatePickupNumber
        mustTarp
        verifyOutboundRailCar
        trackOutboundSeals
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        inventoryPrimaryField
        inventoryPhotos
        trackInventorySeals
        isBarcodeRequired
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        services {
          nextToken
        }
        checklists {
          nextToken
        }
        prompt
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchAssetTypes = /* GraphQL */ `
  query SearchAssetTypes(
    $filter: SearchableAssetTypeFilterInput
    $sort: SearchableAssetTypeSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchAssetTypes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        maxConcurrentBookings
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchCarriers = /* GraphQL */ `
  query SearchCarriers(
    $filter: SearchableCarrierFilterInput
    $sort: SearchableCarrierSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchCarriers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        active
        groups
        businessName
        dbaName
        email
        phone
        normalizedEmail
        normalizedPhone
        identifiers {
          scheme
          value
        }
        companyId
        reloadYardId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchCarrierUserReloadYardCarriers = /* GraphQL */ `
  query SearchCarrierUserReloadYardCarriers(
    $filter: SearchableCarrierUserReloadYardCarrierFilterInput
    $sort: SearchableCarrierUserReloadYardCarrierSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchCarrierUserReloadYardCarriers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        deleted
        carrierUserId
        user {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        businessName
        firstName
        lastName
        email
        phone
        type
        description
        acl
        photo {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes
        blockAccess
        createdVia
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchCustomerReloadYardAccounts = /* GraphQL */ `
  query SearchCustomerReloadYardAccounts(
    $filter: SearchableCustomerReloadYardAccountFilterInput
    $sort: SearchableCustomerReloadYardAccountSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchCustomerReloadYardAccounts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        active
        groups
        email
        lastName
        acl
        description
        customerId
        customer {
          id
          status
          cognitoId
          email
          unsubscribed
          firstName
          lastName
          phone
          createdAt
          updatedAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        accountId
        accountName
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchEventTypes = /* GraphQL */ `
  query SearchEventTypes(
    $filter: SearchableEventTypeFilterInput
    $sort: SearchableEventTypeSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchEventTypes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        areaId
        name
        description
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          owner
          groups
          active
          reloadYardId
          areaId
          name
          maxConcurrentBookings
          createdAt
          updatedAt
        }
        workflow
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchFiles = /* GraphQL */ `
  query SearchFiles(
    $filter: SearchableFileFilterInput
    $sort: SearchableFileSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchFiles(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        displayName
        rawFileName
        description
        contentDate
        category
        visibility
        file {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchHelpPages = /* GraphQL */ `
  query SearchHelpPages(
    $filter: SearchableHelpPageFilterInput
    $sort: SearchableHelpPageSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchHelpPages(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        active
        isLive
        url
        topic
        name
        content
        kbFiles {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        kbMedia {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        kbContent {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        updatedBy
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchInboundShipments = /* GraphQL */ `
  query SearchInboundShipments(
    $filter: SearchableInboundShipmentFilterInput
    $sort: SearchableInboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        poNumber
        normalizedPoNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        originCarrier
        carrierName
        carrierId
        carrier {
          id
          owner
          active
          groups
          businessName
          dbaName
          email
          phone
          normalizedEmail
          normalizedPhone
          companyId
          reloadYardId
          createdAt
          updatedAt
        }
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        lotType
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        advisedBy
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptNumber
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        stockImport
        sit
        returnShipment
        returnOutboundShipmentId
        returnReason
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklistId
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        containerDrop
        containerNumber
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        stepName
        sealNumbers
        seals {
          nextToken
        }
        braData {
          id
          owner
          groups
          reloadYardId
          accountId
          braSessionId
          braRawData
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchInventorys = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityPrecount
        quantityOnHand
        altQuantityOnHand
        quantityPhysical
        quantityCommitted
        altQuantityCommitted
        quantityMismatch
        inventoryUOM
        returnShipmentLineItemId
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        pcsOnHand
        pcsCommitted
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleList
        containerNumber
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        photos {
          nextToken
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        productName
        braRawProductName
        rawDataInventoryId
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          altNames
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          height
          width
          length
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          color
          status
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        workOrderId
        workOrder {
          id
          owner
          groups
          active
          status
          state
          workType
          poNumber
          normalizedPoNumber
          totalUOM
          skipInvoice
          createDateTime
          startDateTime
          endDateTime
          assignedTo
          workflowType
          processedBy
          verificationRequired
          hasException
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          accountName
          accountId
          billToAccountId
          reloadYardId
          inputInventoryId
          invoiceId
          areaId
          zoneId
          reloadYardCommodityId
          customFields
          stepName
          createdAt
          updatedAt
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        aggregateInventoryId
        inventoryItems {
          nextToken
        }
        customFields
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchInventoryItems = /* GraphQL */ `
  query SearchInventoryItems(
    $filter: SearchableInventoryItemFilterInput
    $sort: SearchableInventoryItemSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventoryItems(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        quantityOnHand
        altQuantityOnHand
        quantityCommitted
        altQuantityCommitted
        pcsOnHand
        pcsCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        barcode
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
          isContaminated
          containerNumber
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedAt
        unloadedBy
        depletedAt
        seals {
          nextToken
        }
        barcodes {
          nextToken
        }
        history {
          type
          date
          by
          text
          public
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchInvoices = /* GraphQL */ `
  query SearchInvoices(
    $filter: SearchableInvoiceFilterInput
    $sort: SearchableInvoiceSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInvoices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        poNumbers
        railCarNumbers
        pickupNumbers
        event
        paymentTermId
        paymentTerm {
          id
          owner
          groups
          reloadYardId
          name
          code
          type
          dueDays
          dayOfMonthDue
          sortKey
          createdAt
          updatedAt
        }
        paymentTerms
        createDateTime
        dueDate
        overDue
        sentDate
        paidDate
        lineItems {
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        payments {
          id
          amount
          paymentDate
          method
          reference
          memo
          recordedBy
          recordedAt
        }
        paymentReferences
        notes
        customFields
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        contact {
          name
          email
          phone
          description
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        reloadYardId
        reloadYard {
          id
          owner
          groups
          active
          status
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          latitude
          longitude
          geofence
          geofenceToleranceMeters
          geofenceEnabled
          geofenceEnforced
          driverCheckInEnabled
          driverIdentificationRequired
          driverIdScanRequired
          driverCheckInGraceMinutes
          driverCheckInWithoutAppointment
          driverInstructions
          postCheckInMessage
          driverIdImageRetention
          lotCapacity
          trackCapacity
          warehouseCapacity
          servingCarrier
          railHighway
          ast
          externalCompanyId
          invoiceNumberPrefix
          invoiceCounter
          bolCounter
          receiptCounter
          timeZone
          invoicesProcessedAt
          reportsProcessedAt
          createdAt
          updatedAt
        }
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipmentId
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchInvoiceServices = /* GraphQL */ `
  query SearchInvoiceServices(
    $filter: SearchableInvoiceServiceFilterInput
    $sort: SearchableInvoiceServiceSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInvoiceServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        serviceId
        service {
          id
          owner
          groups
          active
          status
          reloadYardId
          accountName
          accountId
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          createdAt
          updatedAt
        }
        event
        externalId
        sortKey
        accountId
        reloadYardId
        inboundShipmentId
        outboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          normalizedPoNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          originCarrier
          carrierName
          carrierId
          driverId
          driverName
          lotType
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          advisedBy
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          sit
          returnShipment
          returnOutboundShipmentId
          returnReason
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          gateCheckInId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          consigneePoNumber
          normalizedPoNumber
          normalizedPickupNumber
          normalizedConsigneePoNumber
          carrierType
          carrier
          carrierName
          carrierId
          driverId
          driverName
          bolNumber
          railCarNumber
          normalizedRailCarNumber
          carrierEquipmentTypeId
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          signedBy
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          accountName
          accountId
          billToAccountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          gateCheckInId
          shipWithGroupId
          shipWithIds
          advisedBy
          inspectedBy
          stepName
          hasException
          returnShipment
          returnReason
          createdAt
          updatedAt
        }
        quantity
        units
        unitCost
        amount
        itemTax
        taxRate {
          taxCode
          name
          taxRate
        }
        itemTotal
        serviceNote
        serviceDate
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchLogs = /* GraphQL */ `
  query SearchLogs(
    $filter: SearchableLogFilterInput
    $sort: SearchableLogSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchLogs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        createdAt
        appType
        tenantId
        user
        message
        exception
        appVersion
        url
        context
        owner
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchOutboundShipments = /* GraphQL */ `
  query SearchOutboundShipments(
    $filter: SearchableOutboundShipmentFilterInput
    $sort: SearchableOutboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOutboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        carrierType
        carrier
        carrierName
        carrierId
        driverId
        driver {
          id
          status
          cognitoId
          email
          contactEmail
          unsubscribed
          firstName
          lastName
          phone
          userType
          driverCode
          suspendedAt
          suspendedBy
          suspensionReason
          createdAt
          updatedAt
        }
        driverName
        bolNumber
        railCarNumber
        normalizedRailCarNumber
        carrierEquipmentTypeId
        railEquipmentType {
          id
          owner
          groups
          active
          name
          arrTypeCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        truckEquipmentType {
          id
          owner
          groups
          active
          name
          dotSpecCode
          dotClassCode
          length
          reloadYardId
          sortKey
          createdAt
          updatedAt
        }
        mustTarp
        didTarp
        containerPickup
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        signedBy
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        skipInvoice
        photos {
          nextToken
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolFile {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        sealNumber
        assignedTo
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        trackCar {
          id
          active
          owner
          areaId
          zoneId
          aisleId
          trackId
          eodTrackId
          locationFullName
          reloadYardId
          accountId
          shipmentId
          parentType
          railCarNumber
          sortKey
          eodSortKey
          updatedAt
          updatedBy
          createdAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        shipmentLineItems {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        invoicedServices {
          nextToken
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        timeslotId
        gateCheckInId
        shipWithGroupId
        shipWithIds
        timeslot {
          id
          owner
          groups
          status
          reloadYardId
          year
          month
          week
          day
          time
          startTime
          endTime
          inboundId
          outboundId
          accountName
          accountId
          eventTypeId
          carrierId
          carrierUserId
          createdAt
          updatedAt
        }
        advisedBy
        inspectedBy
        stepName
        seals {
          nextToken
        }
        hasException
        returnShipment
        returnReason
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: SearchableProductSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        altNames
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        height
        width
        length
        pcsHeight
        pcsWidth
        pcsLength
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        color
        status
        inventories {
          nextToken
        }
        velocityStats {
          id
          owner
          groups
          productId
          accountId
          reloadYardId
          stats
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchReloadYards = /* GraphQL */ `
  query SearchReloadYards(
    $filter: SearchableReloadYardFilterInput
    $sort: SearchableReloadYardSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchReloadYards(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        status
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        latitude
        longitude
        geofence
        geofenceToleranceMeters
        geofenceEnabled
        geofenceEnforced
        driverCheckInEnabled
        driverIdentificationRequired
        driverIdScanRequired
        driverCheckInGraceMinutes
        driverCheckInWithoutAppointment
        driverInstructions
        postCheckInMessage
        driverStops {
          label
          message
        }
        driverIdImageRetention
        lotCapacity
        trackCapacity
        warehouseCapacity
        servingCarrier
        railHighway
        ast
        externalCompanyId
        taxRates {
          taxCode
          name
          taxRate
        }
        paymentTerms {
          nextToken
        }
        invoiceNumberPrefix
        invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        receiptTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolCounter
        receiptCounter
        fileCategories {
          key
          name
        }
        mapImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        logoImage {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        areas {
          nextToken
        }
        zones {
          nextToken
        }
        aisles {
          nextToken
        }
        yardCommodities {
          nextToken
        }
        subscription {
          customerId
          subscriptionId
          priceId
          name
          status
        }
        tosAccept {
          acceptTimeStamp
          cognitoId
          email
          userAgent
          ip
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        schedule {
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        timeZone
        railEquipmentTypes {
          nextToken
        }
        truckEquipmentTypes {
          nextToken
        }
        assetTypes {
          nextToken
        }
        eventTypes {
          nextToken
        }
        checklists {
          nextToken
        }
        apiKeys {
          nextToken
        }
        invoicesProcessedAt
        reportsProcessedAt
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchSeals = /* GraphQL */ `
  query SearchSeals(
    $filter: SearchableSealFilterInput
    $sort: SearchableSealSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchSeals(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        active
        owner
        groups
        reloadYardId
        accountId
        accountName
        referenceId
        referenceName
        barcode
        isScanned
        createdAt
        createdBy
        validated
        reValidated
        brokenAt
        brokenBy
        description
        status
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchSupportRequests = /* GraphQL */ `
  query SearchSupportRequests(
    $filter: SearchableSupportRequestFilterInput
    $sort: SearchableSupportRequestSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchSupportRequests(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        status
        reloadYardId
        subject
        description
        requirements
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        submittedAt
        approvedPriceCents
        maxRevisions
        approvedBy
        approvedAt
        quoteExpiresAt
        estimatedDays
        stripeCheckoutSessionId
        stripePaymentIntentId
        stripePaymentStatus
        paidAt
        startedAt
        deliveredAt
        revisionCount
        deliveryNotes
        deliveryAttachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchUsers = /* GraphQL */ `
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: SearchableUserSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        status
        cognitoId
        type
        firstName
        lastName
        fullName
        phone
        email
        unsubscribed
        address {
          name
          street
          city
          state
          zipCode
          country
          phone
        }
        reloadYardId
        acl
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const searchWorkOrders = /* GraphQL */ `
  query SearchWorkOrders(
    $filter: SearchableWorkOrderFilterInput
    $sort: SearchableWorkOrderSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchWorkOrders(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        workType
        poNumber
        normalizedPoNumber
        totalUOM
        skipInvoice
        createDateTime
        startDateTime
        endDateTime
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        processedBy
        verificationRequired
        hasException
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
          public
        }
        accountName
        accountId
        billToAccountId
        account {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        billToAccount {
          id
          owner
          groups
          active
          status
          businessName
          displayName
          accountNumber
          externalId
          externalStatus
          accountType
          defaultBillToAccountId
          lotNumberPrefix
          color
          defaultWeightUOM
          paymentTermId
          creditLimit
          overLimit
          overDue
          einNumber
          skipInvoice
          email
          phone
          fax
          website
          billingEmail
          invoiceSubject
          invoiceAttachments
          addressState
          reloadYardId
          inboundInstructions
          secondaryReview
          inboundSkipSignature
          inboundPhotos
          podEmail
          podPhotos
          podAttachments
          podSubject
          inboundAdviceInputs
          inboundEventTypeId
          lotType
          lotNumberOverride
          fifoLotNumber
          carlotLotNumber
          verifyInboundRailCar
          trackInboundSeals
          requireDefaultZone
          outboundInstructions
          posEmail
          posPhotos
          posAttachments
          posSubject
          outboundSkipSignature
          outboundPhotos
          outboundReview
          outboundAdviceInputs
          outboundEventTypeId
          generatePickupNumber
          mustTarp
          verifyOutboundRailCar
          trackOutboundSeals
          inventoryPrimaryField
          inventoryPhotos
          trackInventorySeals
          isBarcodeRequired
          prompt
          createdAt
          updatedAt
        }
        reloadYardId
        inputInventoryId
        inputInventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          normalizedPoNumber
          railCarNumber
          normalizedRailCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityPrecount
          quantityOnHand
          altQuantityOnHand
          quantityPhysical
          quantityCommitted
          altQuantityCommitted
          quantityMismatch
          inventoryUOM
          returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          pcsOnHand
          pcsCommitted
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          containerNumber
          outboundShipmentId
          productName
          braRawProductName
          rawDataInventoryId
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          workOrderId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          createdAt
          updatedAt
        }
        workOrderItems {
          nextToken
        }
        outputInventories {
          nextToken
        }
        manualCharges {
          nextToken
        }
        invoiceId
        invoice {
          id
          owner
          groups
          active
          status
          invoiceNumber
          externalId
          externalUrl
          externalStatus
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          event
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          overDue
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          paymentReferences
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          leasedArea
          leasedAreaUOM
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          showCounter
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
          required
        }
        stepName
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
